{
  "#AccessSettings": "Доступ по ссылке",
  "#AddArch": "Добавить арку",
  "#AddAttic": "Добавить мансарду",
  "#AddLevel": "Добавить этаж",
  "#AddLowerLevel": "Добавить подвал",
  "#AddMolding": "Добавить молдинг",
  "#AddNewItem": "Добавить предмет",
  "#AddPlinths": "Добавить плинтусы",
  "#AddToRoom": "Добавить в комнату",
  "#AgentActionCancelled": "Действие отменено",
  "#AgentAiAgentDescription": "Сам решает, какие агенты нужны: один для небольшой задачи, несколько сразу — для большой, а на вопросы отвечает, не меняя проект.",
  "#AgentAnswerTruncated": "(Ответ оборвался по длине.)",
  "#AgentBridgeAttempt": "Попытка {0}",
  "#AgentBridgeFailed": "{0}. Запустите npm run mcp",
  "#AgentBridgeUnavailable": "Сервер моста недоступен",
  "#AgentCheckingSave": "Проверяем сохранение",
  "#AgentCommandBusy": "Завершите текущее редактирование и повторите действие.",
  "#AgentCommandConflict": "Действие не применено: проект изменился.",
  "#AgentCommandDuplicate": "Номер команды уже использован с другими параметрами.",
  "#AgentCommandFailed": "Действие не выполнено.",
  "#AgentCommandForbidden": "Это вне прав агента.",
  "#AgentCommandInvalid": "Некорректные параметры команды.",
  "#AgentCommandRejected": "Изменения не приняты. Проверьте сохранение и повторите синхронизацию.",
  "#AgentCommandRevisionConflict": "Проект изменился. Это действие не применено.",
  "#AgentCommandScopeConflict": "Открыт другой проект или этаж. Это действие не применено.",
  "#AgentCountItemsFew": "{0} предмета",
  "#AgentCountItemsMany": "{0} предметов",
  "#AgentCountItemsOne": "{0} предмет",
  "#AgentCountRoomsFew": "{0} комнаты",
  "#AgentCountRoomsMany": "{0} комнат",
  "#AgentCountRoomsOne": "{0} комната",
  "#AgentCountWallsFew": "{0} стены",
  "#AgentCountWallsMany": "{0} стен",
  "#AgentCountWallsOne": "{0} стена",
  "#AgentCursorFailed": "Не вышло: {0}",
  "#AgentCursorName": "Агент",
  "#AgentDoneArchAdded": "Добавлен проём: арка",
  "#AgentDoneArrangedAround": "Расставлено вокруг: {0}",
  "#AgentDoneCameraAimed": "Камера наведена",
  "#AgentDoneCatalogFound": "Найдено в каталоге: {0}",
  "#AgentDoneChangeSaved": "Изменение сохранено",
  "#AgentDoneDeleted": "Удалено ({0}): {1}",
  "#AgentDoneDoorAdded": "Добавлен проём: дверь",
  "#AgentDoneEditorStatus": "Проверил связь с редактором",
  "#AgentDoneFinish": "Отделка: {0}",
  "#AgentDoneFloor": "Этаж {0}",
  "#AgentDoneFloorCleared": "Этаж очищен",
  "#AgentDoneItemAdded": "Добавлен предмет: {0}",
  "#AgentDoneItemChanged": "Изменён предмет: {0}",
  "#AgentDoneItemDuplicated": "Продублирован: {0}",
  "#AgentDoneItemReplaced": "Заменён на {0}",
  "#AgentDoneMaterial": "Материал: {0}",
  "#AgentDoneMaterialsFound": "Найдено материалов: {0}",
  "#AgentDoneOpening": "Открываю {0}",
  "#AgentDoneOpeningChanged": "Изменён проём {0}",
  "#AgentDonePanelOpened": "Открыта панель: {0}",
  "#AgentDonePanelsClosed": "Панели закрыты",
  "#AgentDonePlacedAlongWall": "Расставлено вдоль стены: {0}",
  "#AgentDonePlacedBeside": "Поставлено рядом: {0}",
  "#AgentDonePlanSnapshot": "Снимок плана",
  "#AgentDoneProjectCreated": "Создан проект «{0}»",
  "#AgentDoneProjectList": "Список проектов",
  "#AgentDoneReadScene": "Прочитал сцену",
  "#AgentDoneRedone": "Повторено шагов: {0}",
  "#AgentDoneRenamed": "Переименован: «{0}»",
  "#AgentDoneRenderReady": "Рендер готов",
  "#AgentDoneReport": "Отчёт: {0}",
  "#AgentDoneReports": "Отчёты агентов: {0}",
  "#AgentDoneReportsFailed": "Отчёты агентов: {0} ({1} с ошибкой)",
  "#AgentDoneRoomAdded": "Добавлена комната #{0} «{1}»",
  "#AgentDoneRoomChanged": "Изменена комната #{0}",
  "#AgentDoneRoomFurnishedFew": "Обставлена комната #{1}: {0} предмета",
  "#AgentDoneRoomFurnishedMany": "Обставлена комната #{1}: {0} предметов",
  "#AgentDoneRoomFurnishedOne": "Обставлена комната #{1}: {0} предмет",
  "#AgentDoneSelected": "Выделено",
  "#AgentDoneSelectionCleared": "Выделение снято",
  "#AgentDoneUndone": "Отменено шагов: {0}",
  "#AgentDoneViewSnapshot": "Снимок 3D-вида",
  "#AgentDoneViewSwitched": "Вид переключён",
  "#AgentDoneWallAdded": "Добавлена стена {0}→{1}",
  "#AgentDoneWallChanged": "Изменена стена {0}",
  "#AgentDoneWallsAdded": "Добавлены стены",
  "#AgentDoneWholeFloor": "Показан весь этаж",
  "#AgentDoneWindowAdded": "Добавлен проём: окно",
  "#AgentErrorApiKey": "Ключ API не принят. Проверьте ключ в настройках агента.",
  "#AgentErrorBadRequest": "Модель отклонила запрос: {0}",
  "#AgentErrorForbidden": "Доступ запрещён: {0}",
  "#AgentErrorNoConnection": "Нет связи с сервисом модели. Проверьте сеть и повторите.",
  "#AgentErrorNotConfigured": "Агент не настроен на сервере: на прокси агента нет ключа этого провайдера. Выберите другого провайдера или укажите свой ключ в настройках агента.",
  "#AgentErrorRateLimit": "Слишком много запросов к модели. Подождите немного и повторите.",
  "#AgentErrorServiceDown": "Сервис модели временно недоступен. Повторите через минуту.",
  "#AgentEstimateName": "Агент сметы",
  "#AgentExternalName": "Внешний агент",
  "#AgentHealthAllOk": "Всё, на что опирается агент, отвечает.",
  "#AgentHealthBots": "Боты-агенты",
  "#AgentHealthBotsReadyFew": "{0} агента в проекте — курсоры на сцене, вид открывается по аватару в шапке",
  "#AgentHealthBotsReadyMany": "{0} агентов в проекте — курсоры на сцене, вид открывается по аватару в шапке",
  "#AgentHealthBotsReadyOne": "{0} агент в проекте — курсоры на сцене, вид открывается по аватару в шапке",
  "#AgentHealthBotsRunning": "Зову ботов-агентов",
  "#AgentHealthBotsUnavailable": "недоступны: открыт общий проект или редактор не готов",
  "#AgentHealthCatalog": "Каталог моделей",
  "#AgentHealthCatalogAnswered": "отвечает за {0}: {1} моделей в разделе «{2}»",
  "#AgentHealthCatalogRunning": "Спрашиваю каталог",
  "#AgentHealthFailedList": "Не работает: {0}.",
  "#AgentHealthLocalDown": "локальный агент не отвечает",
  "#AgentHealthLocalDownDetail": "локальный агент не отвечает ({0})",
  "#AgentHealthLocalUp": "локальный агент Claude Code отвечает",
  "#AgentHealthLocalUpProject": "локальный агент Claude Code отвечает, проект «{0}»",
  "#AgentHealthMaterialsAnswered": "отвечают за {0}: {1} в разделе «{2}»",
  "#AgentHealthMaterialsRunning": "Загружаю материалы",
  "#AgentHealthMockMode": "учебный режим: ответы без модели",
  "#AgentHealthModel": "Модель",
  "#AgentHealthModelAnswered": "{0} ответила за {1}",
  "#AgentHealthModelAnsweredText": "{0} ответила за {1} («{2}»)",
  "#AgentHealthModelMissing": "не подключена — запросы идут в симуляцию",
  "#AgentHealthModelRunning": "Спрашиваю модель",
  "#AgentHealthName": "Проверка",
  "#AgentHealthNoFrame": "кадр не получен",
  "#AgentHealthNoMaterialSections": "разделов материалов нет",
  "#AgentHealthNoModelNote": "Без модели агенты отвечают в режиме симуляции: покажут работу на проекте, не меняя его. Модель подключается в настройках агента.",
  "#AgentHealthNoSofas": "раздела диванов нет в дереве каталога",
  "#AgentHealthNoView": "вид редактора недоступен",
  "#AgentHealthOpenAICompatible": "OpenAI-совместимый",
  "#AgentHealthProject": "Чтение проекта",
  "#AgentHealthProjectCounts": "{0}, {1}, {2} на этаже",
  "#AgentHealthProjectRunning": "Читаю проект инструментом агента",
  "#AgentHealthRequest": "Проверь работоспособность агента",
  "#AgentHealthServer": "Сервер агента",
  "#AgentHealthServerDown": "не отвечает — модели через сервер редактора нет",
  "#AgentHealthServerKeys": "отвечает, ключи: {0}",
  "#AgentHealthServerNoKey": "отвечает, но ключа модели на нём нет",
  "#AgentHealthServerRunning": "Проверяю сервер агента",
  "#AgentHealthSnapshot": "Снимок вида",
  "#AgentHealthSnapshotRunning": "Снимаю текущий вид",
  "#AgentHealthSnapshotTaken": "{0}, {1} КБ — агент видит то же, что вы",
  "#AgentHealthStageReady": "сцена готова показать субагентов за работой",
  "#AgentHealthSummary": "Проверка завершена: работает {0} из {1}.",
  "#AgentHealthToolSilent": "инструмент не ответил",
  "#AgentHealthViewOrbit": "обзор в 3D",
  "#AgentHealthViewPlan": "план",
  "#AgentHealthViewWalk": "прогулка в 3D",
  "#AgentKitchenName": "Агент кухни",
  "#AgentLightingName": "Агент освещения",
  "#AgentLocalFailed": "Локальный агент завершил работу с ошибкой.",
  "#AgentLocalHttpError": "Локальный агент ответил ошибкой HTTP {0}.",
  "#AgentLocalLimit": "Лимит подписки Claude Code исчерпан на этот период. Попробуйте позже или смените модель на sonnet.",
  "#AgentLocalModelDefault": "Как в Claude Code",
  "#AgentLocalNoOk": "сервер ответил без ok",
  "#AgentLocalNotLoggedIn": "Claude Code не вошёл в аккаунт. Откройте claude в терминале, выполните /login (вход по подписке) и повторите.",
  "#AgentLocalNotOnBridge": "страница ещё не подключена к мосту",
  "#AgentLocalNotRunning": "Локальный агент не запущен. Выполните в папке проекта: npm run agent:local",
  "#AgentLocalStartHint": "запустите npm run agent:local",
  "#AgentMeasureName": "Агент обмеров",
  "#AgentMockDone": "Готово (учебный ответ без модели): сцену прочитал, изменения применил. Скажите, что поправить.",
  "#AgentMockLooking": "Смотрю на сцену…",
  "#AgentMockRoomName": "Комната агента",
  "#AgentModelRefused": "Модель отказалась выполнять этот запрос.",
  "#AgentNewChat": "Новый чат",
  "#AgentNewProjectName": "Мой интерьер",
  "#AgentOpenProjectFirst": "Откройте проект — агент работает внутри редактора.",
  "#AgentPanelAgentChat": "Чат с агентом",
  "#AgentPanelAgentSnapshot": "Снимок, который увидел агент",
  "#AgentPanelAgentThinking": "Агент думает",
  "#AgentPanelAiAgent": "ИИ-агент",
  "#AgentPanelAnthropicKey": "Ключ API Anthropic",
  "#AgentPanelAttachView": "Приложить снимок текущего вида",
  "#AgentPanelBackToChats": "К списку чатов",
  "#AgentPanelBridgeConnected": "Мост подключён: инструменты редактора доступны внешним агентам.",
  "#AgentPanelBridgeConnecting": "Подключаюсь к мосту…",
  "#AgentPanelBridgeOffline": "Мост не отвечает{0}.",
  "#AgentPanelBuiltInModel": "Модель ИИ-агента и его субагентов",
  "#AgentPanelChatActions": "Действия: {0}",
  "#AgentPanelChatName": "Название чата",
  "#AgentPanelChatsEmpty": "Чаты с агентом по этому проекту будут собираться здесь.",
  "#AgentPanelCheckingServer": "Проверяю сервер…",
  "#AgentPanelCloseSettings": "Закрыть настройки",
  "#AgentPanelCollapseChat": "Свернуть чат",
  "#AgentPanelCollapseEsc": "Свернуть (Esc)",
  "#AgentPanelDefaultModel": "По умолчанию ({0})",
  "#AgentPanelDeleteChat": "Удалить чат",
  "#AgentPanelEarlier": "Раньше",
  "#AgentPanelEmptyIntro": "{0} — {1} Напишите, что сделать в проекте, или выберите пример:",
  "#AgentPanelErrorTime": "Ошибка {0}",
  "#AgentPanelExternalAgents": "Внешние агенты",
  "#AgentPanelExternalText": "Принимать команды от Claude Code, Claude Desktop и других MCP-клиентов",
  "#AgentPanelExternalTitle": "Внешние агенты (MCP)",
  "#AgentPanelFinishedFailed": "Завершено · Не выполнено: {0}",
  "#AgentPanelHealthCheck": "Проверка работоспособности",
  "#AgentPanelLiveDemo": "Живое демо 2D / 3D",
  "#AgentPanelLocalAgent": "Локальный агент",
  "#AgentPanelLocalChecking": "Локальный агент…",
  "#AgentPanelLocalLogin": "Один раз войдите в Claude Code в терминале ({0}, затем {1}), потом запускайте сервер в папке проекта:",
  "#AgentPanelLocalModel": "Модель локального агента",
  "#AgentPanelLocalOffline": "Локальный агент не запущен",
  "#AgentPanelLocalReady": "Локальный агент готов",
  "#AgentPanelLocalServerOffline": "Сервер не отвечает на {0}{1}.",
  "#AgentPanelLocalServerReady": "Сервер локального агента отвечает{0}.",
  "#AgentPanelLocalServerReadyProject": "Сервер локального агента отвечает, проект «{0}»{1}.",
  "#AgentPanelLocalText": "Выполнять задания через Claude Code на этом компьютере — по подписке, без ключа API",
  "#AgentPanelLocalTitle": "Локальный агент (подписка Claude Code)",
  "#AgentPanelLocalUrl": "Адрес локального агента",
  "#AgentPanelMcpConnected": "MCP подключён",
  "#AgentPanelMcpConnecting": "MCP: подключение…",
  "#AgentPanelMcpOffline": "MCP: нет связи",
  "#AgentPanelMcpRun": "Запустите на этом компьютере {0} в папке проекта и добавьте сервер клиенту:",
  "#AgentPanelMinutes": "{0} мин",
  "#AgentPanelMinutesSeconds": "{0} мин {1} с",
  "#AgentPanelMockLabel": "Учебный режим без модели",
  "#AgentPanelMockText": "Учебный режим: отвечать без модели (для проверки интерфейса)",
  "#AgentPanelModel": "Модель",
  "#AgentPanelModelCheck": "Модель: {0}. Проверить агентов без неё:",
  "#AgentPanelModelDefault": "По умолчанию для агента",
  "#AgentPanelModelName": "Название модели",
  "#AgentPanelModelNamePlaceholder": "Название модели, например gpt-5",
  "#AgentPanelNewChat": "Новый чат",
  "#AgentPanelNoModel": "Модель не подключена.",
  "#AgentPanelNoModelText": "Агенты покажут работу на вашем проекте в режиме симуляции, не меняя его.",
  "#AgentPanelOpenChat": "Открыть чат",
  "#AgentPanelOtherModel": "Другая модель…",
  "#AgentPanelOwnKeyText": "Без ключа запросы идут через сервер редактора. Со своим ключом браузер обращается к Anthropic напрямую; ключ хранится только в этом браузере.",
  "#AgentPanelOwnKeyTitle": "Свой ключ API",
  "#AgentPanelProjectNotChanged": "Проект не изменён",
  "#AgentPanelProvider": "Провайдер",
  "#AgentPanelProviderAuto": "Выбран автоматически по ключам сервера редактора.",
  "#AgentPanelProviderChecking": "Проверяю, какие ключи есть на сервере…",
  "#AgentPanelProviderKey": "Ключ провайдера",
  "#AgentPanelProviderKeyPlaceholder": "Ключ провайдера (необязательно, если он есть на сервере)",
  "#AgentPanelProviderModel": "Модель провайдера",
  "#AgentPanelProviderNoKeys": "На сервере редактора нет ключей: выберите провайдера и введите свой ключ.",
  "#AgentPanelProviderNoServerKey": "На сервере редактора ключа нет: введите свой (он хранится только в этом браузере) или задайте AGENT_OPENAI_API_KEY на сервере.",
  "#AgentPanelProviderServerKey": "На сервере редактора есть ключ этого провайдера; без своего ключа запросы идут через него.",
  "#AgentPanelProviderServerKeyAt": "На сервере редактора есть ключ этого провайдера ({0}); без своего ключа запросы идут через него.",
  "#AgentPanelProviderTitle": "Провайдер модели",
  "#AgentPanelProviderUrl": "Адрес API провайдера",
  "#AgentPanelReasoning": "Размышления",
  "#AgentPanelRemoveSnapshot": "Убрать снимок",
  "#AgentPanelRetry": "Повторить",
  "#AgentPanelRollback": "Откатить ответ",
  "#AgentPanelRollbackSteps": "Откатить ответ ({0})",
  "#AgentPanelRolledBack": "Изменения возвращены",
  "#AgentPanelRunningOpen": "Агент работает — открыть чат",
  "#AgentPanelSeconds": "{0} с",
  "#AgentPanelSendEnter": "Отправить (Enter)",
  "#AgentPanelSettings": "Настройки агента",
  "#AgentPanelShowView": "Показать агенту текущий вид",
  "#AgentPanelSimulate": "Симуляция агентов",
  "#AgentPanelSimulateLook": "Посмотри на проект",
  "#AgentPanelStampDate": "{0} {1}",
  "#AgentPanelStampToday": "сегодня {0}",
  "#AgentPanelStampYesterday": "вчера {0}",
  "#AgentPanelStepsFew": "{0} шага",
  "#AgentPanelStepsMany": "{0} шагов",
  "#AgentPanelStepsOne": "{0} шаг",
  "#AgentPanelStepsThinking": "{0}, думаю…",
  "#AgentPanelStepsWithFailed": "{0}, {1} с ошибкой",
  "#AgentPanelStop": "Остановить",
  "#AgentPanelStopAgent": "Остановить агента",
  "#AgentPanelStopped": "Остановлен",
  "#AgentPanelStoppedStatus": "Остановлено",
  "#AgentPanelStoppedTime": "Остановлен {0}",
  "#AgentPanelSubagentDone": "готово",
  "#AgentPanelSubagentFailed": "с ошибкой",
  "#AgentPanelSubagentWorking": "работает…",
  "#AgentPanelSuggest3D": "Покажи результат в 3D",
  "#AgentPanelSuggestBedroom": "Построй спальню и поставь кровать",
  "#AgentPanelSuggestFloor": "Сделай пол из светлого дуба",
  "#AgentPanelSuggestFurnish": "Обставь самую большую комнату",
  "#AgentPanelSuggestProjects": "Какие есть готовые проекты?",
  "#AgentPanelSuggestRender": "Сделай рендер в стиле сканди",
  "#AgentPanelSuggestRoom": "Создай комнату 5×4 м с окном",
  "#AgentPanelSuggestWindow": "Добавь окно на длинную стену",
  "#AgentPanelTaskLabel": "Задание агенту",
  "#AgentPanelTaskPlaceholder": "Дайте любое задание",
  "#AgentPanelThinking": "Думаю…",
  "#AgentPanelThinkingModeLabel": "Режим размышлений модели",
  "#AgentPanelThinkingModeText": "Режим размышлений (DeepSeek думает перед каждым шагом: точнее, но в разы медленнее)",
  "#AgentPanelUndoAll": "Весь ответ тоже откатывается одним нажатием.",
  "#AgentPanelUndoEach": "Каждое действие можно отменить по отдельности.",
  "#AgentPanelViewSnapshot": "Снимок вида",
  "#AgentPanelWorked": "Работал",
  "#AgentPanelWorkedTime": "Работал {0}",
  "#AgentPanelWorking": "Агент работает…",
  "#AgentPanelWorkingOnRequest": "Работаю над запросом…",
  "#AgentProjectFallbackName": "Проект",
  "#AgentProviderClosed": "Провайдер закрыл поток без ответа.",
  "#AgentProviderDown": "Сервис провайдера временно недоступен. Повторите через минуту.",
  "#AgentProviderError": "Ошибка провайдера",
  "#AgentProviderKeyRejected": "Ключ провайдера не принят. Проверьте ключ в настройках агента.",
  "#AgentProviderNoBody": "Провайдер ответил без тела.",
  "#AgentProviderNoConnection": "Нет связи с провайдером. Проверьте адрес API и сеть.",
  "#AgentProviderNoFunds": "На счёте провайдера нет средств.",
  "#AgentProviderNoFundsDetail": "На счёте провайдера нет средств ({0}).",
  "#AgentProviderNotFound": "Модель или адрес не найдены у провайдера.",
  "#AgentProviderNotFoundDetail": "Модель или адрес не найдены у провайдера: {0}.",
  "#AgentProviderOpenAICompatible": "OpenAI-совместимый API (DeepSeek, OpenAI…)",
  "#AgentProviderRateLimit": "Провайдер ограничил число запросов. Подождите и повторите.",
  "#AgentProviderRejected": "Провайдер отклонил запрос (HTTP {0}).",
  "#AgentProviderRejectedDetail": "Провайдер отклонил запрос (HTTP {0}): {1}.",
  "#AgentRenderName": "Агент рендеров",
  "#AgentReviewName": "Агент проверки",
  "#AgentRightsRefused": "Не моя задача — проект не изменён",
  "#AgentRollbackBusy": "Завершите текущее редактирование. Откат не выполнен.",
  "#AgentRollbackChanged": "После этого ответа проект изменился. Откат не выполнен, чтобы сохранить новые изменения.",
  "#AgentRollbackChecking": "Проверяем сохранение отмены…",
  "#AgentRollbackExternal": "Ответ выполнялся через внешний мост. Чтобы сохранить другие изменения, используйте отмену по шагам.",
  "#AgentRollbackRename": "Переименование проекта не откатывается вместе с ответом. Используйте отмену по шагам для изменений плана.",
  "#AgentRollbackRunning": "Дождитесь завершения текущего ответа. Откат не выполнен.",
  "#AgentSeconds": "{0} с",
  "#AgentSimAccents": "Выбираю акцентные цвета подушек",
  "#AgentSimAccentsDone": "Акцент — терракота и олива",
  "#AgentSimAnswerCatalog": "- Каталог: {0}.",
  "#AgentSimAnswerCatalogPicked": "- Каталог: выбрал {0}.",
  "#AgentSimAnswerDecor": "- Декор: {0}.",
  "#AgentSimAnswerFailedSteps": "Не получилось шагов: {0} — подробности в карточках агентов.",
  "#AgentSimAnswerFloor": "Готово — агенты разобрали этаж по запросу «{0}».",
  "#AgentSimAnswerLayout": "- Планировка: {0}.",
  "#AgentSimAnswerNamedRoom": "Готово — агенты разобрали «{0}» по запросу «{1}».",
  "#AgentSimAnswerNote": "Это симуляция: агенты показали работу на вашем проекте, сам проект не изменён. Чтобы они выполняли задания, подключите модель в настройках агента.",
  "#AgentSimAnswerRoom": "Готово — агенты разобрали комнату {0} м² по запросу «{1}».",
  "#AgentSimAnswerStyle": "- Стиль: {0}.",
  "#AgentSimAxis": "Считаю ось расстановки",
  "#AgentSimAxisCenter": "Ось — по центру комнаты",
  "#AgentSimAxisWall": "Ось — вдоль стены {0} м",
  "#AgentSimCatalogSilent": "каталог не ответил",
  "#AgentSimChoiceDeferred": "Выбор отложен до ответа каталога",
  "#AgentSimChoosingModel": "Выбираю модель",
  "#AgentSimCoffeeTable": "Выбираю журнальный столик",
  "#AgentSimCoffeeTableLater": "Столик подберу после расстановки",
  "#AgentSimCoffeeTablePicked": "Выбрал столик {0}",
  "#AgentSimCurtainFabric": "Подбираю ткань штор",
  "#AgentSimCurtainFabricDone": "Ткань штор — лён, бежевый",
  "#AgentSimCurtainTone": "Сверяю тон штор со стенами",
  "#AgentSimCurtainToneDone": "Тон штор — на полтона светлее стен",
  "#AgentSimCushions": "Подбираю подушки",
  "#AgentSimCushionsDone": "По две подушки на каждый диван",
  "#AgentSimCushionsLater": "Подушки подберу к дивану",
  "#AgentSimDecorUnfinished": "не завершён",
  "#AgentSimDefaultRequest": "Обставь самую большую комнату",
  "#AgentSimFailed": "Симуляция прервалась: {0}",
  "#AgentSimFinishCustom": "своя картинка",
  "#AgentSimFinishDefault": "по умолчанию",
  "#AgentSimFoundModels": "Нашёл {0} моделей в разделе «{1}»",
  "#AgentSimItem": "предмет",
  "#AgentSimKept": "Оставил «{0}»",
  "#AgentSimKeptNoChange": "Оставил «{0}» — замена не нужна",
  "#AgentSimLookRequest": "Посмотри на проект",
  "#AgentSimMarkingZones": "Размечаю зоны мебели",
  "#AgentSimMeasured": "Измерил комнату: {0} × {1} м, {2} м²",
  "#AgentSimMeasuredNamed": "Измерил «{0}»: {1} × {2} м, {3} м²",
  "#AgentSimMeasuring": "Измеряю комнату",
  "#AgentSimModelBySize": "модель {0} × {1} см",
  "#AgentSimModelTitled": "«{0}» ({1} × {2} см)",
  "#AgentSimName": "Агенты · симуляция",
  "#AgentSimNoRooms": "Комнат на этаже нет — нужен план",
  "#AgentSimNoSection": "Раздела {0} нет в дереве каталога",
  "#AgentSimOpenProjectFirst": "Откройте проект — агенты работают внутри редактора.",
  "#AgentSimPalette": "Анализирую палитру",
  "#AgentSimPaletteDone": "Палитра: пол — {0}, стены — {1}",
  "#AgentSimPaletteUnread": "палитра не прочитана",
  "#AgentSimPicked": "Выбрал {0}",
  "#AgentSimPickedFrom": "{0} из раздела «{1}»",
  "#AgentSimRoomEmpty": "Комната пустая — зоны свободны",
  "#AgentSimSearchingModels": "Ищу модели в каталоге",
  "#AgentSimSectionEmpty": "Раздел «{0}» пока пуст",
  "#AgentSimStepFailed": "{0}: не получилось",
  "#AgentSimZonesMarked": "Разметил зоны: {0} в комнате",
  "#AgentStepDone": "Выполнено",
  "#AgentStopped": "Остановлено.",
  "#AgentToolAddItem": "Ставлю предмет",
  "#AgentToolAddOpening": "Добавляю проём",
  "#AgentToolAddRoom": "Строю комнату",
  "#AgentToolAddWall": "Строю стену",
  "#AgentToolArrangeAround": "Расставляю вокруг",
  "#AgentToolCaptureView": "Смотрю на сцену",
  "#AgentToolClearLevel": "Очищаю этаж",
  "#AgentToolDelegate": "Передаю задачу",
  "#AgentToolDelete": "Удаляю",
  "#AgentToolDuplicateItem": "Дублирую предмет",
  "#AgentToolEditorStatus": "Проверяю связь",
  "#AgentToolFocus": "Навожу камеру",
  "#AgentToolFurnishRoom": "Обставляю комнату",
  "#AgentToolHistory": "Отменяю шаг",
  "#AgentToolPlaceAlongWall": "Расставляю вдоль стены",
  "#AgentToolPlaceBeside": "Ставлю рядом",
  "#AgentToolProject": "Работаю с проектами",
  "#AgentToolReadScene": "Читаю сцену",
  "#AgentToolRenderAi": "Рендерю",
  "#AgentToolReplaceItem": "Заменяю предмет",
  "#AgentToolSearchCatalog": "Ищу в каталоге",
  "#AgentToolSearchMaterials": "Ищу материал",
  "#AgentToolSelect": "Выделяю",
  "#AgentToolSetFloor": "Переключаю этаж",
  "#AgentToolSetMaterial": "Наношу материал",
  "#AgentToolSetRoomFinish": "Подбираю отделку",
  "#AgentToolSetView": "Переключаю вид",
  "#AgentToolShowPanel": "Открываю панель",
  "#AgentToolUpdateItem": "Двигаю предмет",
  "#AgentToolUpdateOpening": "Меняю проём",
  "#AgentToolUpdateRoom": "Меняю комнату",
  "#AgentToolUpdateWall": "Меняю стену",
  "#AiRenderFailedWith": "Рендер не удался: {0}",
  "#AiRenderNoId": "Сервер не вернул идентификатор рендера",
  "#AiRenderNoImage": "Рендер завершился без изображения",
  "#AiRenderNotFound": "Рендер не найден на сервере",
  "#AiRenderRejected": "Сервер отклонил рендер: HTTP {0}",
  "#AiRenderStatusFailed": "Статус рендера: HTTP {0}",
  "#AiRenderTimeout": "Рендер идёт дольше {0} мин. Сервер продолжает работу, результат появится в галерее.",
  "#AllFloors": "Все этажи",
  "#AllRooms": "Все комнаты",
  "#AnyoneCanEdit": "Любой, у кого есть ссылка, может редактировать",
  "#AnyoneCanView": "Любой, у кого есть ссылка, может просматривать",
  "#AppAccessClosed": "Доступ к проекту закрыт",
  "#AppAskingCatalog": "Спрашиваем каталог о моделях…",
  "#AppAskOwnerForLink": "Попросите владельца прислать новую ссылку.",
  "#AppBackToProjects": "К моим проектам",
  "#AppCollaborationUnavailable": "Совместная работа пока недоступна. Подключение сервиса ещё готовится.",
  "#AppLoadingModels": "Загружаем модели: {0} из {1}",
  "#AppLocalProjectNotFound": "Локальный проект не найден в этом браузере.",
  "#ApplyToAllHint_CeilingMolding": "Применить ко всем потолочным плинтусам в комнате",
  "#ApplyToAllHint_Floor": "Применить ко всем комнатам этажа",
  "#ApplyToAllHint_Plinth": "Применить ко всем плинтусам в комнате",
  "#ApplyToAllWithCount": "Для всех ({0})",
  "#AppModelsPending": "Готовятся ещё {0}: появятся по мере готовности",
  "#AppOpenFailed": "Не удалось открыть проект {0}: {1}",
  "#AppOpenFailedTitle": "Не открылось",
  "#AppProjectFallbackName": "Проект",
  "#AppProjectInTrash": "Проект в «Недавно удалённых». Восстановите его в «Моих проектах», чтобы открыть.",
  "#AppRetryConnection": "Повторить подключение",
  "#AppSharedProjectName": "Общий проект",
  "#Area": "Площадь",
  "#AtticSlopedCeiling": "Наклонный потолок",
  "#Awesome": "Круто!",
  "#Benefit3dsMax": "3ds Max",
  "#BenefitCatalog": "Каталог",
  "#CameraAiPhoto": "Аи фото",
  "#CameraAiRedesign": "Аи редизайн",
  "#CameraAiRenderResult": "Результат AI-рендера",
  "#CameraAnotherShot": "Ещё кадр",
  "#CameraAskingServer": "Спрашиваем сервер…",
  "#CameraAskServer": "Спросить сервер о рендере",
  "#CameraAspect": "Формат кадра",
  "#CameraCapturedShot": "Снятый кадр",
  "#CameraClose": "Закрыть камеру",
  "#CameraCloseGallery": "Закрыть галерею",
  "#CameraCloseViewer": "Закрыть просмотр",
  "#CameraDeleteAgainNote": "Ещё раз, чтобы удалить",
  "#CameraDeleteConfirm": "Нажмите ещё раз, чтобы удалить",
  "#CameraDeleteForever": "Удалить безвозвратно?",
  "#CameraElapsedSeconds": "{0} с",
  "#CameraGalleryEmptyHint": "Наведите камеру и нажмите затвор.",
  "#CameraGalleryEmptySubtitle": "Ваши фото и рендеры",
  "#CameraGalleryEmptyText": "Здесь появятся ваши кадры и рендеры.",
  "#CameraGalleryEmptyTitle": "Сохраните первый кадр",
  "#CameraHoldOriginal": "Показать исходный кадр, удерживайте",
  "#CameraItemActions": "Действия: {0} {1}",
  "#CameraLightboxCount": "{0} из {1}",
  "#CameraMinimize": "Свернуть",
  "#CameraModeGroup": "Режим камеры",
  "#CameraNewShot": "Новый кадр",
  "#CameraNext": "Следующий",
  "#CameraNextShot": "Следующий кадр",
  "#CameraOpenOriginal": "Открыть оригинал",
  "#CameraOriginalShot": "Исходный кадр",
  "#CameraPrevious": "Предыдущий",
  "#CameraPreviousShot": "Предыдущий кадр",
  "#CameraPrompt": "Пожелания к рендеру",
  "#CameraPromptPhotoPlaceholder": "Пожелания: вечернее освещение…",
  "#CameraPromptQuoted": "«{0}»",
  "#CameraPromptRedesignPlaceholder": "Что изменить: больше растений, тёплый свет…",
  "#CameraQualityNeedsAccount": "{0} — доступно с аккаунтом каталога",
  "#CameraQualitySide": "{0} — до {1} px по длинной стороне",
  "#CameraRedesignStyle": "Стиль редизайна",
  "#CameraRenderFailed": "Рендер не удался",
  "#CameraRendering": "Рендерим…",
  "#CameraRenderingElapsed": "Рендерим… {0}",
  "#CameraRenderingElapsedBusy": "Рендерим… {0} · сервер занят, ждём до 5 минут",
  "#CameraRenderingShort": "Рендерим",
  "#CameraRenderNumber": "№ {0}",
  "#CameraSceneNotReady": "Сцена ещё не готова к съёмке.",
  "#CameraServerStillRendering": "Сервер ещё рендерит",
  "#CameraShoot": "Сделать рендер",
  "#CameraShotCount": "Кадров: {0}",
  "#CameraShotFailed": "Не удалось снять кадр сцены.",
  "#CameraShotFailedWith": "Не удалось снять кадр: {0}",
  "#CameraStillRenderingToast": "Сервер ещё рендерит. Результат появится в галерее.",
  "#CameraZoom": "Зум",
  "#CanEdit": "Редактор",
  "#CanView": "Гость",
  "#CanViewDesc": "Только просмотр. Редактирование недоступно.",
  "#CatalogApiConversionTimeout": "Конвертация не завершилась за 10 минут",
  "#CatalogApiHttpError": "Каталог: HTTP {0} на {1}",
  "#CatalogDrawerClearSearch": "Очистить поиск",
  "#CatalogDrawerCollapse": "Свернуть каталог",
  "#CatalogDrawerFavoritesEmpty": "Отмечайте модели звёздочкой — они соберутся здесь",
  "#CatalogDrawerForgetRecent": "Удалить из недавних",
  "#CatalogDrawerForgetRecentNamed": "Удалить из недавних: {0}",
  "#CatalogDrawerGoToCategories": "Перейти в категории",
  "#CatalogDrawerLoadingModels": "Загружаем модели",
  "#CatalogDrawerLoadingMore": "Загружаем ещё модели",
  "#CatalogDrawerLoadingSuggestions": "Загружаем подсказки",
  "#CatalogDrawerMoreFailed": "Следующие модели не загрузились",
  "#CatalogDrawerNoAnswer": "Каталог не ответил",
  "#CatalogDrawerNothingFound": "По запросу «{0}» ничего не нашлось",
  "#CatalogDrawerPopular": "Популярные запросы",
  "#CatalogDrawerPreparing": "{0} — при первом добавлении модель готовится несколько секунд",
  "#CatalogDrawerRecentPopular": "Недавние и популярные запросы",
  "#CatalogDrawerRefine": "Уточнить",
  "#CatalogDrawerResults": "Результаты поиска: {0}",
  "#CatalogDrawerSave": "В избранное",
  "#CatalogDrawerSaveNamed": "В избранное: {0}",
  "#CatalogDrawerSearch": "Поиск по каталогу",
  "#CatalogDrawerSearchCurtains": "Поиск штор",
  "#CatalogDrawerSearchDoor": "Поиск двери",
  "#CatalogDrawerSearchEverywhere": "Искать «{0}» по всему каталогу",
  "#CatalogDrawerSearchWindow": "Поиск окна",
  "#CatalogDrawerSectionEmpty": "В этом разделе пока нет моделей",
  "#CatalogDrawerSections": "Разделы каталога",
  "#CatalogDrawerSuggestions": "Подсказки",
  "#CatalogDrawerTitle": "Каталог",
  "#CatalogDrawerUnsave": "Убрать из избранного",
  "#CatalogDrawerUnsaveNamed": "Убрать из избранного: {0}",
  "#CatalogStateModel": "Модель",
  "#CatalogStatePicture": "Картинка",
  "#CeilingHeight": "Высота потолка",
  "#CeilingPlan2DView": "План потолка",
  "#ChangeFloorplanScale": "Изменить масштаб плана",
  "#ChangeFloorPlanScale": "Изменить масштаб",
  "#ChatAllReactions": "Все реакции",
  "#ChatCancelEdit": "Отменить изменение",
  "#ChatCancelEsc": "Отменить (Esc)",
  "#ChatCancelReply": "Отменить ответ",
  "#ChatClickToRemove": "Нажмите, чтобы убрать",
  "#ChatCloseChat": "Закрыть чат",
  "#ChatCloseEsc": "Закрыть (Esc)",
  "#ChatComposerLabel": "Сообщение участникам проекта",
  "#ChatConnectFailed": "Не удалось подключиться к чату.",
  "#ChatConnecting": "Подключаемся к чату…",
  "#ChatCopyFailed": "Не удалось скопировать текст",
  "#ChatCopyText": "Копировать текст",
  "#ChatDeleteText": "Сообщение исчезнет у всех участников чата.",
  "#ChatDeleteTitle": "Удалить сообщение?",
  "#ChatDelivered": "Доставлено, ещё не прочитано",
  "#ChatDemoAmbient1": "Я пока посмотрю спальню — кто-нибудь занимается кухней?",
  "#ChatDemoAmbient2": "Гляньте гостиную в 3D: по-моему, стало светлее.",
  "#ChatDemoDone1": "Отлично, выглядит хорошо!",
  "#ChatDemoDone2": "Супер, посмотрю через минуту.",
  "#ChatDemoFallback1": "Понятно 👍",
  "#ChatDemoFallback2": "Хорошо, учту.",
  "#ChatDemoFallback3": "Давайте так и сделаем.",
  "#ChatDemoFallback4": "Звучит хорошо.",
  "#ChatDemoFinish1": "Светлые стены здесь смотрятся лучше.",
  "#ChatDemoFinish2": "Попробуйте светлый дуб на полу — будет теплее.",
  "#ChatDemoFurniture1": "Диван лучше развернуть к окну — так светлее.",
  "#ChatDemoFurniture2": "Могу подобрать пару вариантов из каталога.",
  "#ChatDemoHello1": "Привет! 👋",
  "#ChatDemoHello2": "Привет, я тут — смотрю план.",
  "#ChatDemoKitchen1": "На кухне у окна мало места — может, сдвинем стол?",
  "#ChatDemoKitchen2": "Кухню посмотрю после гостиной.",
  "#ChatDemoLaugh1": "😂",
  "#ChatDemoLaugh2": "Ну да, так и есть 😄",
  "#ChatDemoOpening1": "Окно можно сделать шире, стена позволяет.",
  "#ChatDemoOpening2": "Дверь лучше открывать внутрь комнаты.",
  "#ChatDemoQuestion1": "Хороший вопрос — сейчас посмотрю в проекте.",
  "#ChatDemoQuestion2": "Думаю, да. Давайте проверим в 3D.",
  "#ChatDemoQuestion3": "Можно попробовать: покажу вариант на плане.",
  "#ChatDemoSeed1": "Привет! Планировка уже в проекте — гостиную можно сделать светлее.",
  "#ChatDemoSeed2": "Поддерживаю. И диван лучше развернуть к окну.",
  "#ChatDemoTask1": "Хорошо, займусь.",
  "#ChatDemoTask2": "Сейчас сделаю.",
  "#ChatDemoThanks1": "Не за что 🙂",
  "#ChatDemoThanks2": "Обращайтесь!",
  "#ChatDemoView1": "Сейчас гляну в 3D.",
  "#ChatDemoView2": "Сделаю рендер, когда закончим с мебелью.",
  "#ChatDisconnected": "Нет связи с чатом. Новые сообщения придут, когда она вернётся.",
  "#ChatDismissNotice": "Скрыть сообщение",
  "#ChatEdited": "изменено",
  "#ChatEditingMessage": "Изменение сообщения",
  "#ChatEditPlaceholder": "Измените сообщение",
  "#ChatEmptyText": "Напишите участникам проекта: они увидят сообщение сразу, а вы — кто его прочитал.",
  "#ChatEmptyTitle": "Сообщений пока нет",
  "#ChatIntroFineprint": "Совместная работа ещё подключается к серверу приложения. Посмотреть, как всё устроено, можно на примере с демо-участниками.",
  "#ChatIntroText": "Пригласите людей через «Поделиться» — здесь будут сообщения, реакции, кто прочитал и кто сейчас печатает.",
  "#ChatIntroTitle": "Чат участников проекта",
  "#ChatJumpDown": "Вниз",
  "#ChatJumpToLast": "К последнему сообщению",
  "#ChatJumpToNew": "К новым сообщениям: {0}",
  "#ChatLoading": "Загружаем сообщения…",
  "#ChatMessage": "Сообщения",
  "#ChatMessageActions": "Действия с сообщением",
  "#ChatMessageDeleted": "Сообщение удалено",
  "#ChatMessageLabelDeleted": "{0}, {1}, сообщение удалено",
  "#ChatMoreMessageActions": "Ещё действия с сообщением",
  "#ChatNamesMore": "{0}, {1} и ещё {2}",
  "#ChatNamesThree": "{0}, {1} и {2}",
  "#ChatNamesTwo": "{0} и {1}",
  "#ChatNewCount": "Новых: {0}",
  "#ChatNewMessages": "Новые сообщения",
  "#ChatNotAllSent": "Не всё отправлено: нет связи с чатом. Отправим, как только связь вернётся.",
  "#ChatNotLoadedText": "Они появятся здесь, как только чат подключится.",
  "#ChatNotLoadedTitle": "Сообщения не загрузились",
  "#ChatNotSent": "Не отправлено",
  "#ChatOnlyYou": "Пока только вы",
  "#ChatParticipant": "Участник",
  "#ChatProjectChat": "Чат проекта",
  "#ChatProjectChatUnread": "Чат проекта, непрочитанных: {0}",
  "#ChatQuoteGone": "Ответ на сообщение, которого уже нет",
  "#ChatQuoteLabel": "Ответ на сообщение {0}: {1}. Показать его",
  "#ChatQuoteUnavailable": "Недоступно",
  "#ChatReact": "Отреагировать",
  "#ChatReactionAdore": "Восторг",
  "#ChatReactionAffection": "Нежность",
  "#ChatReactionAngry": "Злость",
  "#ChatReactionApplause": "Аплодисменты",
  "#ChatReactionAwkward": "Неловко",
  "#ChatReactionCelebration": "Праздник",
  "#ChatReactionChange": "Реакция: {0}. Изменить",
  "#ChatReactionCool": "Круто",
  "#ChatReactionDeal": "Договорились",
  "#ChatReactionFire": "Огонь",
  "#ChatReactionHeart": "Сердце",
  "#ChatReactionHmm": "Хм",
  "#ChatReactionHome": "Дом",
  "#ChatReactionHooray": "Ура",
  "#ChatReactionHundred": "Сто из ста",
  "#ChatReactionLaugh": "Смех",
  "#ChatReactionLike": "Нравится",
  "#ChatReactionLooking": "Смотрю",
  "#ChatReactionOops": "Упс",
  "#ChatReactionPaint": "Краски",
  "#ChatReactionParty": "Вечеринка",
  "#ChatReactionSad": "Грусть",
  "#ChatReactionsList": "Реакции: {0}",
  "#ChatReactionSmile": "Улыбка",
  "#ChatReactionSofa": "Диван",
  "#ChatReactionSparkle": "Блеск",
  "#ChatReactionStarStruck": "Звёзды в глазах",
  "#ChatReactionStrong": "Сила",
  "#ChatReactionSurprise": "Удивление",
  "#ChatReactionThanks": "Спасибо",
  "#ChatReactorOwn": "{0}: {1}. Убрать",
  "#ChatReadBy": "Прочитано: {0}",
  "#ChatReplyTo": "Ответ: {0}",
  "#ChatRetry": "Повторить",
  "#ChatSaveChanges": "Сохранить изменения",
  "#ChatSaveEnter": "Сохранить (Enter)",
  "#ChatSendEnter": "Отправить (Enter)",
  "#ChatSending": "Отправляется",
  "#ChatShowExample": "Показать пример",
  "#ChatTypingSeveral": "{0} печатают…",
  "#ChatTypingSingle": "{0} печатает…",
  "#ChatUnavailableText": "Сервер совместной работы ещё не передаёт сообщения. Как только начнёт, переписка появится здесь.",
  "#ChatUnavailableTitle": "Чат пока не подключён",
  "#ChatWaitingForServer": "Ждёт сервер совместной работы",
  "#ChatYou": "Вы",
  "#ChatYouAnd": "Вы, {0}",
  "#ChooseAnotherImg": "Выбрать другое изображение",
  "#CloneEntireRoom": "Клонировать всю комнату",
  "#CloneNightstandHint": "Нажми на кнопку, чтобы клонировать мебель",
  "#CloneRoomWalls": "Клонировать только стены",
  "#CollabAllMembers": "Все участники",
  "#CollabAllMembersUnread": "Все участники, непрочитанных сообщений: {0}",
  "#CollabAskOwnerForLink": "Попросите владельца прислать новую ссылку.",
  "#CollabBackToProjects": "К моим проектам",
  "#CollabCheckingInvite": "Проверяем приглашение…",
  "#CollabCheckingSave": "Проверяем сохранение…",
  "#CollabCheckingSaveOffline": "Проверяем сохранение. Подключитесь к сети и повторите синхронизацию.",
  "#CollabClickToFollow": "нажмите, чтобы следить за видом",
  "#CollabClickToStopFollowing": "нажмите, чтобы перестать следить",
  "#CollabConnectionLost": "Соединение потеряно. Восстанавливаем совместную работу.",
  "#CollabErrorConflict": "Действие не применено: проект изменился. Синхронизируйте проект и повторите редактирование.",
  "#CollabErrorConnect": "Не удалось подключиться. Проверьте интернет и повторите попытку.",
  "#CollabErrorDenied": "Доступ к проекту закрыт.",
  "#CollabErrorForbidden": "Доступ к этому проекту закрыт. Попросите владельца прислать новую ссылку.",
  "#CollabErrorInvalidLink": "Ссылка недействительна или уже отключена. Попросите новую ссылку у владельца.",
  "#CollabErrorPendingUnreadable": "Не удалось прочитать ожидающее сохранение. Сохраните копию перед очисткой данных браузера.",
  "#CollabErrorRepeat": "Не удалось повторить запрос. Исходный проект сохранён в этом браузере.",
  "#CollabErrorStorageBlocked": "Браузер не разрешает сохранять гостевой доступ. Разрешите хранение данных для этого сайта и повторите.",
  "#CollabErrorStorageFull": "Не удалось сохранить данные в браузере. Освободите место и повторите.",
  "#CollabErrorWriteChanges": "Не удалось записать изменения в браузере. Освободите место или разрешите хранилище и повторите синхронизацию.",
  "#CollabEyebrow": "СОВМЕСТНАЯ РАБОТА",
  "#CollabFinishOrCancelChange": "Завершите или отмените изменение",
  "#CollabFollowAfterConnecting": "Слежение доступно после подключения",
  "#CollabFollowingThisView": "Вы следите за этим видом",
  "#CollabFollowLoop": "Нельзя следовать друг за другом по кругу",
  "#CollabFollowMemberView": "Следить за видом участника",
  "#CollabFollowName": "Следить за {0}",
  "#CollabFollowSeeing": "Вы видите то же, что {0}",
  "#CollabFollowSwitching": "Переходим к виду: {0}",
  "#CollabGuestNote": "Гостевой доступ сохранится в этом браузере. Одинаковые имена не объединяют участников.",
  "#CollabInProjectNow": "Сейчас в проекте",
  "#CollabJoining": "Присоединяемся…",
  "#CollabJoinLead": "Присоединитесь, чтобы редактировать интерьер вместе с другими участниками.",
  "#CollabManageAccess": "Настроить доступ",
  "#CollabMemberFallback": "участник",
  "#CollabMemberTab": "{0} · вкладка {1}",
  "#CollabMemberViewUnavailable": "Вид участника сейчас недоступен",
  "#CollabNamePlaceholder": "Как вас увидят участники",
  "#CollabNoConnection": "Нет соединения",
  "#CollabOpeningShared": "Открываем общий проект…",
  "#CollabPerfLabel": "Производительность участников",
  "#CollabPerfReadout": "{0} fps · кадр p95 {1} ms · участники p95 {2} ms · React {3}/s",
  "#CollabPointersLabel": "Курсоры участников",
  "#CollabProjectChat": "Чат проекта",
  "#CollabProjectChatUnread": "Чат проекта, непрочитанных: {0}",
  "#CollabRefreshConnection": "Обновить соединение",
  "#CollabResponseDelayed": "Ответ задерживается. Проверяем сохранение…",
  "#CollabRetryCheck": "Повторить проверку",
  "#CollabSessionChanged": "Сеанс совместной работы изменился",
  "#CollabSharedProject": "Общий проект",
  "#CollabStatusConflict": "Действие не применено: проект изменился",
  "#CollabStatusConnecting": "Подключаемся…",
  "#CollabStatusDenied": "Доступ к проекту закрыт",
  "#CollabStatusOffline": "Нет соединения · редактирование приостановлено",
  "#CollabStatusPreview": "Предпросмотр · изменения ещё не применены",
  "#CollabStatusReconnecting": "Восстанавливаем соединение…",
  "#CollabStatusSaved": "Все изменения сохранены",
  "#CollabStatusSaving": "Сохраняем…",
  "#CollabStopFollowing": "Перестать следить",
  "#CollabStopFollowingHint": "Перестать следить (Esc)",
  "#CollabStopFollowingName": "Перестать следить за {0}",
  "#CollabUnavailable": "Совместная работа пока недоступна. Подключение сервиса ещё готовится.",
  "#CollabViewUnavailable": "Вид сейчас недоступен",
  "#CollabYourName": "Ваше имя",
  "#ColumnsAndBeams": "Колонны и балки",
  "#ContextBarCatalogUnavailable": "Каталог недоступен",
  "#ContextBarCatalogUnavailableDetail": "Не удалось спросить каталог: {0}. Нажмите, чтобы попробовать снова.",
  "#ContextBarDeleteSelected": "Удалить выбранные",
  "#ContextBarDoneEsc": "Готово (Esc)",
  "#ContextBarDragToMove": "Потяните, чтобы сдвинуть панель",
  "#ContextBarDuplicateSelected": "Дублировать выбранные",
  "#ContextBarFieldCm": "{0}, см",
  "#ContextBarFieldRange": "{0}: от {1} до {2} см",
  "#ContextBarItemCountFew": "{0} предмета",
  "#ContextBarItemCountMany": "{0} предметов",
  "#ContextBarItemCountOne": "{0} предмет",
  "#ContextBarItemSize": "Размер предмета",
  "#ContextBarMirror": "Зеркально",
  "#ContextBarModelConverting": "Конвертируется прямо сейчас. Появится сама через несколько секунд.",
  "#ContextBarModelDamaged": "Модель повреждена, пока её не получается показать",
  "#ContextBarModelFailed": "Модель не подготовлена",
  "#ContextBarModelFailedRetry": "Не удалось подготовить модель. Попробуйте ещё раз",
  "#ContextBarModelMissing": "Модели нет в каталоге",
  "#ContextBarModelMissingDetail": "Каталог не знает такой модели: её нет на сервере. Предмет остаётся на плане как коробка.",
  "#ContextBarModelPreparing": "Модель готовится",
  "#ContextBarModelQueued": "В очереди на подготовку для веба. Появится сама, как только будет готова.",
  "#ContextBarNoConnection": "нет связи",
  "#ContextBarOpeningSize": "Размер проёма",
  "#ContextBarOpeningSizesCm": "Размеры проёма, см",
  "#ContextBarRange": "От {0} до {1} см",
  "#ContextBarResetRotation": "Сбросить поворот",
  "#ContextBarResetToCatalogSize": "Вернуть размер из каталога",
  "#ContextBarRotate90": "Повернуть на 90°",
  "#ContextBarSelectionActions": "Действия с выбранным объектом",
  "#ContextBarSelectionShortcuts": "Переходы для выбранного объекта",
  "#ContextBarSizesCm": "Размеры, см",
  "#ContextCommandsNoRoomForCopy": "Рядом на стене нет места для копии.",
  "#ContextCommandsWallTooShortToSplit": "Стена слишком короткая, чтобы её разделить.",
  "#CopyLink": "Копировать ссылку",
  "#CrmAndSheets": "CRM и таблицы",
  "#Curtains": "Шторы",
  "#CurtainsChangeButton": "Выбрать шторы",
  "#CustomColourHex": "Цвет в HEX",
  "#CustomColourHue": "Оттенок",
  "#CustomColourTitle": "Свой цвет",
  "#DeleteForever": "Удалить навсегда",
  "#DeleteItem": "Удалить предмет",
  "#DeleteRoom": "Удалить комнату?",
  "#DemoBotCatalogAgent": "Агент каталога",
  "#DemoBotCatalogItem": "подбирает замену: {0}",
  "#DemoBotCatalogOrbit": "сверяет каталог",
  "#DemoBotCatalogPlan": "ищет место для мебели",
  "#DemoBotCatalogWalk": "смотрит мебель",
  "#DemoBotCheckingOpening": "проверяет проём",
  "#DemoBotCheckingWall": "сверяет стену",
  "#DemoBotDecorAgent": "Агент декора",
  "#DemoBotDecorItem": "примеряет {0}",
  "#DemoBotDecorOrbit": "смотрит композицию",
  "#DemoBotDecorPlan": "ищет место для декора",
  "#DemoBotDecorWalk": "расставляет декор",
  "#DemoBotItem": "предмет",
  "#DemoBotLayoutAgent": "Агент планировки",
  "#DemoBotLayoutItem": "двигает {0}",
  "#DemoBotLayoutOrbit": "осматривает этаж",
  "#DemoBotLayoutPlan": "проверяет планировку",
  "#DemoBotLayoutWalk": "проходит по комнате",
  "#DemoBotPersonItem": "смотрит {0}",
  "#DemoBotPersonOrbit": "смотрит проект",
  "#DemoBotPersonPlan": "смотрит план",
  "#DemoBotPersonWalk": "гуляет по комнате",
  "#DemoBotStyleAgent": "Агент стиля",
  "#DemoBotStyleItem": "сверяет цвет: {0}",
  "#DemoBotStyleOrbit": "смотрит свет",
  "#DemoBotStylePlan": "сверяет цвета",
  "#DemoBotStyleWalk": "смотрит отделку",
  "#DemoControlsClose": "Закрыть симуляцию",
  "#DemoControlsCrowd": "Количество участников",
  "#DemoControlsDemo": "Демо",
  "#DemoControlsLabel": "Симуляция участников",
  "#DemoControlsParticipantsFew": "{0} участника",
  "#DemoControlsParticipantsMany": "{0} участников",
  "#DemoControlsParticipantsOne": "{0} участник",
  "#DemoControlsPauseSimulation": "Приостановить симуляцию",
  "#DemoControlsResume": "Продолжить",
  "#DemoControlsResumeSimulation": "Продолжить симуляцию",
  "#DemoControlsSelectionAuto": "Все выделения",
  "#DemoControlsSelections": "Выделения участников",
  "#DemoControlsViewAuto": "Смена видов",
  "#DemoControlsViewFloor": "Все в 2D",
  "#DemoControlsViewOrbit": "Все в 3D",
  "#DemoControlsViews": "Виды участников",
  "#DemoControlsViewWalk": "Прогулка",
  "#DemoModeHintDescription1": "Смотри дизайн на весь экран — удобно для презентации и проверки.",
  "#DemoModeHintDescription2": "Чтобы записать экран, включи запись на устройстве. Демо-режим этого не сделает.",
  "#DemoModeHintTitle": "Демо-режим",
  "#DemoProjectCoverAlt": "{0}: вид проекта в 3D",
  "#DemoProjectFloorsFew": "{0} этажа",
  "#DemoProjectFloorsMany": "{0} этажей",
  "#DemoProjectFloorsOne": "{0} этаж",
  "#DemoProjectKitchenLivingName": "Кухня-гостиная",
  "#DemoProjectKitchenLivingSummary": "Одна комната, но подробная: кухня со встроенной техникой, остров, свет и декор.",
  "#DemoProjectOpen": "Открыть готовый проект «{0}»",
  "#DemoProjectRoomsFew": "{0} комнаты",
  "#DemoProjectRoomsMany": "{0} комнат",
  "#DemoProjectRoomsOne": "{0} комната",
  "#DemoProjectSlowNote": "Первая загрузка занимает около минуты.",
  "#DemoProjectThreeFloorsName": "Дом в три этажа",
  "#DemoProjectThreeFloorsSummary": "Три разных этажа с мебелью и лестницей между ними — самый большой из готовых проектов.",
  "#DemoProjectTwoFloorsName": "Дом в два этажа",
  "#DemoProjectTwoFloorsSummary": "Готовая коробка дома: комнаты, окна и двери. Планировка обоих этажей одинаковая, мебель расставляйте сами.",
  "#DemoteToGuest": "Понизить до гостя",
  "#DoorSlopes": "Дверные откосы",
  "#DoorType": "Тип двери",
  "#DrawManually": "Рисовать вручную",
  "#DrawWallHint": "Нажми здесь, чтобы начать рисовать стены",
  "#EditorAddTool": "Добавить: {0}",
  "#EditorAddToThisWall": "Добавить на эту стену: {0}",
  "#EditorBackToProjects": "Вернуться к проектам",
  "#EditorCancelOpening": "Отменить открытие",
  "#EditorCeilingNumber": "Потолок {0}",
  "#EditorCeilingPlanStepper": "Потолок на плане",
  "#EditorClear": "Очистить",
  "#EditorClearPlan": "Очистить план",
  "#EditorClearPlanQuestion": "Очистить план?",
  "#EditorClearPlanText": "Стены и предметы будут удалены. Действие можно отменить.",
  "#EditorCloneRoom": "Клонировать комнату",
  "#EditorCloneRoomText": "Копия встанет рядом, на ближайшем свободном месте, со стенами, дверями, окнами и отделкой.",
  "#EditorCloseLighting": "Закрыть освещение",
  "#EditorCloseMessage": "Закрыть сообщение",
  "#EditorCollaborating": "Совместная работа",
  "#EditorCornerBottomLeft": "Левый нижний угол",
  "#EditorCornerBottomRight": "Правый нижний угол",
  "#EditorCornerTopLeft": "Левый верхний угол",
  "#EditorCornerTopRight": "Правый верхний угол",
  "#EditorDeleteFloorQuestion": "Удалить {0}?",
  "#EditorDeleteFloorRowLabel": "Удалить: {0}",
  "#EditorDeleteFloorText": "Всё, что есть на этом этаже, удалится.",
  "#EditorDeleteRoom": "Удалить комнату",
  "#EditorDeleteRoomText": "Уйдут её стены, кроме общих с соседними комнатами, двери и окна в них и всё, что стоит и висит в комнате. Действие можно отменить.",
  "#EditorDemo": "Демо",
  "#EditorDemoTooltip": "Демонстрационный обзор: прогулка на весь экран",
  "#EditorDrawWalls": "Рисовать стены",
  "#EditorDuplicateFloorLabel": "Дублировать: {0}",
  "#EditorEdgeBottom": "Низ, подоконник",
  "#EditorEdgeLeft": "Левый край",
  "#EditorEdgeRight": "Правый край",
  "#EditorEdgeTop": "Верх",
  "#EditorEnterNumber": "Введите число.",
  "#EditorErrorDetails": "Подробности ошибок",
  "#EditorExitDemo": "Выйти из демо",
  "#EditorExportJson": "Экспортировать JSON",
  "#EditorExportProject": "Экспортировать проект",
  "#EditorFinishWalls": "Закончить рисование стен",
  "#EditorFinishWallsTooltip": "Закончить рисование стен (Esc или правая кнопка завершают цепочку)",
  "#EditorFitPlan": "Вписать план",
  "#EditorFitWall": "Вписать стену",
  "#EditorFloor": "Этаж",
  "#EditorFloorAddedAboveStairs": "Над лестницей добавлен «{0}»",
  "#EditorFloorName": "Название этажа",
  "#EditorFloorNoticeGo": "Перейти",
  "#EditorFloorPlanTile": "План пола",
  "#EditorHeightHandleLabel": "Высота от пола: потяните или нажимайте стрелки",
  "#EditorHeightHandleValueLabel": "Высота от пола {0}: потяните или нажимайте стрелки",
  "#EditorHeightTooltip": "Потяните вверх или вниз · стрелки ±1 см, с Shift ±10 см · Enter — положение",
  "#EditorHideDemoBots": "Убрать ботов-агентов",
  "#EditorHideDimensions": "Скрыть размеры",
  "#EditorHideNotice": "Скрыть",
  "#EditorHintMakePhoto": "В твоей комнате появилась мебель. Сделай реалистичное фото и покажи семье и друзьям",
  "#EditorHistory": "История",
  "#EditorImportFailed": "Не удалось прочитать проект.",
  "#EditorImportJson": "Загрузить проект JSON",
  "#EditorImportNotProject": "Это не файл проекта Home Planner Web. Выберите JSON, сохранённый через экспорт проекта.",
  "#EditorImportTooLarge": "Выберите JSON проекта размером до 20 МБ.",
  "#EditorItemsLoading": "Загружаем предметы",
  "#EditorItemsLoadingProgress": "Загрузка предметов",
  "#EditorLoadingEyebrow": "ВАШ ИНТЕРЬЕР",
  "#EditorModelLoadingStatus": "Загрузка 3D-моделей",
  "#EditorModelsFailed": "Не удалось подготовить модели: {0}. Выберите предмет, чтобы увидеть причину",
  "#EditorModelsNotLoaded": "Не загрузились: {0}. Остальные модели доступны.",
  "#EditorModelsNotLoadedCount": "Не загрузились: {0}.",
  "#EditorModelsPreparing": "Готовим модели: {0} — появятся в проекте по мере готовности",
  "#EditorModelsPreparingFailed": "Готовим модели: {0}, не удалось подготовить: {1} — появятся в проекте по мере готовности",
  "#EditorModeSwitch": "Режим",
  "#EditorNextCeiling": "Следующий потолок",
  "#EditorNextWall": "Следующая стена",
  "#EditorNoSceneHint": "Сначала нарисуйте стены или комнату: на этом этаже пока нечего показать в 3D",
  "#EditorOpening": "Проём",
  "#EditorOpeningNoWall": "Двери и окна встают в стену, а рядом нет стены, куда поместится этот проём.",
  "#EditorOpeningProject": "Открываем пространство для ваших идей…",
  "#EditorOpeningScene": "Открываем сцену…",
  "#EditorOpeningToolHint": "Перетащите на стену или нажмите и укажите место",
  "#EditorOrbit": "Обзор",
  "#EditorPlanCanvasLabel": "План помещения: комнаты, стены, углы и мебель. Выберите комнату нажатием, затем перетащите её или круглый маркер.",
  "#EditorPlanCanvasTooltip": "Комната: нажмите для выделения, затем перетащите · Alt + перетаскивание мебели — копия · Ctrl / ⌘ — без привязок · Shift — движение по одной оси",
  "#EditorPlanRotationHint": "Тяните круглую ручку по кругу — повернутся все этажи. У прямых углов план задерживается.",
  "#EditorPlanRotationTitle": "Поворот плана.",
  "#EditorPlanScaleHint": "Нажмите на длину стены или на площадь комнаты и введите настоящее значение.",
  "#EditorPlanScaleTitle": "Масштаб плана.",
  "#EditorPlanScaleWhat": "Что масштабировать",
  "#EditorPlanSurface": "Плоскость плана",
  "#EditorPreviousCeiling": "Предыдущий потолок",
  "#EditorPreviousWall": "Предыдущая стена",
  "#EditorProjectFallbackName": "Проект",
  "#EditorProjectMenu": "Меню проекта",
  "#EditorProjects": "Проекты",
  "#EditorRealRoomArea": "Настоящая площадь помещения",
  "#EditorRealWallLength": "Настоящая длина стены",
  "#EditorRecenterView": "Центрировать вид",
  "#EditorRecognitionCheck": "Проверьте результат.",
  "#EditorRemoveWallQuestion": "Удалить стену?",
  "#EditorRemoveWallText": "Скрытая стена остаётся границей комнаты: на плане она видна пунктиром, в 3D её нет. Любое действие можно отменить.",
  "#EditorRenameFloorLabel": "Переименовать: {0}",
  "#EditorResizeHandleLabel": "{0}: потяните или нажимайте стрелки",
  "#EditorResizeHandleSizeLabel": "{0} {1}: потяните или нажимайте стрелки",
  "#EditorResizeHandleTitle": "{0}: потяните · стрелки ±1 см, с Shift ±10 см",
  "#EditorRetryModels": "Повторить загрузку моделей",
  "#EditorRoomArea": "Площадь помещения",
  "#EditorRoomShapeAdding": "Добавляем…",
  "#EditorRoomShapeLoadFailed": "Не удалось загрузить готовую комнату. Проверьте соединение и выберите её ещё раз.",
  "#EditorRoomShapes": "Готовая комната",
  "#EditorRoomShapesBeside": "Готовая комната встанет рядом с планом, с дверью, окнами и отделкой",
  "#EditorRoomShapesHeading": "Готовая комната с дверью, окнами и отделкой",
  "#EditorRoomShapesShort": "Готовая",
  "#EditorRoomToolHint": "Выберите два противоположных угла перетаскиванием",
  "#EditorRotatePlan": "Повернуть план",
  "#EditorRotatePlanHandle": "Повернуть план, сейчас {0}°",
  "#EditorRotatePlanHandleTooltip": "Потяните по кругу · стрелки ±1°, с Shift ±15°",
  "#EditorRotateTooltip": "Потяните для поворота · Enter — 90°",
  "#EditorRulerHint": "Протяните по плану от точки до точки — длина встанет на линии.",
  "#EditorRulerTitle": "Линейка.",
  "#EditorSavedInBrowser": "Сохранено в этом браузере",
  "#EditorSaveRetry": "Повторить",
  "#EditorSavesInBrowser": "Изменения сохраняются в этом браузере",
  "#EditorScaleByAreaNote": "Площадь пересчитает масштаб всего плана.",
  "#EditorScaleByLengthNote": "Весь план станет в той же мере больше или меньше.",
  "#EditorSceneFps": "FPS сцены",
  "#EditorSceneReady": "Сцена готова: {0} предметов, {1} проёмов",
  "#EditorSceneReadyPanels": "Сцена готова: {0} предметов, {1} проёмов, {2} панелей",
  "#EditorShareProject": "Поделиться проектом",
  "#EditorShowCeiling": "Показывать потолок",
  "#EditorShowDemoBots": "Показать ботов-агентов (пример)",
  "#EditorShowDimensions": "Показать размеры",
  "#EditorSillHeight": "От пола",
  "#EditorSillLetter": "от пола",
  "#EditorSizeLetterDepth": "Г",
  "#EditorSizeLetterHeight": "В",
  "#EditorSizeLetterWidth": "Ш",
  "#EditorSizeTypeExactLabel": "{0} {1}, ввести точно",
  "#EditorSizeTypeExactTitle": "{0}: ввести точно",
  "#EditorStatsHud": "{0} FPS · {1}/{2} предметов",
  "#EditorThisFloor": "Этот этаж",
  "#EditorUnsavedChanges": "Есть несохранённые изменения",
  "#EditorWalk": "Прогулка",
  "#EditorWalkStickHint": "Ведите пальцем по кругу — идти. Палец на картинке — осмотреться, двумя пальцами — шагать и приближать, двойное касание — подойти.",
  "#EditorWalkStickLabel": "Ходьба: ведите пальцем в сторону шага",
  "#EditorWallItemNoWall": "Это вешают на стену, а рядом нет стены, куда оно поместится.",
  "#EditorWallModeLabel": "Стены: {0}",
  "#EditorWallNumber": "Стена {0}",
  "#EditorWallOpeningsToolbar": "Проёмы на стене",
  "#EditorWallPlanNeedsRoom": "Сначала нарисуйте комнату: план стены показывает стену с помещением за ней",
  "#EditorWallPlanStepper": "Стена на плане",
  "#EditorWindowView": "Вид из окна",
  "#EditRoomHintTitle": "Нажми здесь, чтобы задать форму и размер комнаты",
  "#EnterRoom": "Войти в комнату",
  "#ExportFloorplan": "Экспортировать план",
  "#ExportPDF": "Экспорт PDF",
  "#ExteriorPerimeter": "Внешний периметр",
  "#ExternalDimensions": "Внешние размеры",
  "#FailedRenderButtonText": "Повторить",
  "#Floor0": "Цокольный этаж",
  "#Floor1": "Первый этаж",
  "#Floor2": "Второй этаж",
  "#Floor3": "Третий этаж",
  "#Floor4": "Четвертый этаж",
  "#Floor5": "Пятый этаж",
  "#Floor6": "Шестой этаж",
  "#FloorPlan2DView": "План помещения",
  "#FloorPlanAbandonedRow": "Этаж {0} — остановлен",
  "#FloorPlanImportRetry": "Попробовать снова",
  "#FloorPlanImportTimeout": "Не удалось распознать план. Попробуйте ещё раз или загрузите другое фото.",
  "#FloorPlanNotRecognizedRow": "Этаж {0} — план не распознан",
  "#FloorPlanNotStartedRow": "Этаж {0} — не запускался",
  "#FloorPlanReadyRow": "Этаж {0} — готов",
  "#FloorPlanScaleNotMatchedRow": "Этаж {0} — масштаб не сведён",
  "#FloorPlanTimedOutRow": "Этаж {0} — не дождались распознавания",
  "#FolderDaysLeftFew": "Осталось {0} дня",
  "#FolderDaysLeftMany": "Осталось {0} дней",
  "#FolderDaysLeftOne": "Остался {0} день",
  "#FolderLessThanDayLeft": "Осталось меньше дня",
  "#FolderRecentlyDeleted": "Недавно удалённые",
  "#Furnish3DHintTitle": "Перейди в 3D, чтобы добавить мебель и шторы",
  "#GeometryCheckOpeningSize": "Проверьте размеры проёма.",
  "#GeometryCheckSizes": "Проверьте размеры.",
  "#GeometryCheckWallSize": "Проверьте толщину и высоту стены.",
  "#GeometryConnectionTargetGone": "Цель соединения больше не существует.",
  "#GeometryCornerBreaksRoom": "Этот угол пересекает или схлопывает комнату.",
  "#GeometryCornerMergeBlocked": "Нельзя объединить угол: на исчезающей стене есть проём или предмет.",
  "#GeometryDrawLongerWall": "Нарисуйте стену длиной хотя бы 20 см.",
  "#GeometryEnterFiniteRoomPosition": "Введите конечные координаты комнаты.",
  "#GeometryEnterFiniteSizes": "Введите конечные числовые размеры.",
  "#GeometryEnterValidTextureScale": "Введите корректный масштаб текстуры.",
  "#GeometryEnterValidTextureTransform": "Введите корректное преобразование текстуры.",
  "#GeometryItemNotFound": "Предмет не найден.",
  "#GeometryJunctionLeavesShortWall": "У стыка остаётся стена короче 20 см.",
  "#GeometryJunctionPointUndeletable": "Точку, где сходятся три и больше стен, удалить нельзя.",
  "#GeometryMoveBreaksRoom": "Перемещение пересекает или схлопывает комнату.",
  "#GeometryMoveBreaksRoomOutline": "Перемещение нарушает контур комнаты.",
  "#GeometryMoveCollapsesAllRooms": "Перемещение схлопывает все комнаты.",
  "#GeometryMoveCollapsesRoom": "Перемещение схлопывает комнату.",
  "#GeometryNewWallThroughOpening": "Новая стена проходит через проём.",
  "#GeometryNoPlaceForPoint": "Точку негде поставить.",
  "#GeometryOpeningDoesNotFit": "Проём не помещается в стену.",
  "#GeometryOpeningNotFound": "Проём не найден.",
  "#GeometryOpeningOrphan": "Проём потерял связь со стеной.",
  "#GeometryOpeningPastWallEnd": "Проём выходит за край стены.",
  "#GeometryOpeningsOverlap": "Проёмы не должны пересекаться.",
  "#GeometryRoomCopyNotClosed": "Копия комнаты не замкнулась.",
  "#GeometryRoomEnclosed": "Эту комнату со всех сторон окружают другие, и её стены остаются их стенами. Удалите стену между ней и соседней — они станут одной комнатой.",
  "#GeometryRoomNoClosedContour": "У комнаты не найден замкнутый контур стен.",
  "#GeometryRoomNotFound": "Комната не найдена.",
  "#GeometryShapeHasNoRoom": "В этой форме нет комнаты.",
  "#GeometryWallAlreadyHere": "На этом месте уже есть стена.",
  "#GeometryWallEndsCantConnect": "Концы стены не могут соединиться без изменения её длины.",
  "#GeometryWallNotFound": "Стена не найдена.",
  "#GeometryWallsCross": "Стены не должны пересекаться без общего угла.",
  "#GeometryWallSegmentGone": "Участок стены больше не существует.",
  "#GeometryWallsOverlap": "Стены не должны накладываться друг на друга.",
  "#GeometryWallTooShort": "Длина стены должна быть не меньше 20 см.",
  "#GotIt": "Понятно",
  "#GoTo2D": "Перейти в 2D",
  "#GoTo3D": "Перейти в 3D",
  "#GroundSurfaceWithInteriorwalls": "Поверхность пола с внутренними стенами",
  "#GroundSurfaceWithoutWalls": "Поверхность пола без стен",
  "#GroundSurfaceWithWalls": "Поверхность пола со стенами",
  "#HelpAndFeedback": "Помощь и поддержка",
  "#HideWall": "Скрыть стену",
  "#HomeAccountCard": "Аккаунт Home Planner",
  "#HomeAccountHeadline": "Идеи начинаются с вас",
  "#HomeAccountProjectsText": "Возвращайтесь к ним с этого устройства. Для резервной копии используйте экспорт в редакторе.",
  "#HomeAccountProjectsTitle": "Ваши проекты под рукой",
  "#HomeAccountText": "Создавайте интерьеры и сохраняйте кадры. Сейчас вы работаете как гость: проекты и галерея хранятся в этом браузере.",
  "#HomeAccountTitle": "Ваш Home Planner",
  "#HomeAllProjects": "Все проекты",
  "#HomeAutosaveCaption": "Изменения сохраняются автоматически.",
  "#HomeBlankSheet": "Чистый лист",
  "#HomeBrandLabel": "Home Planner — главная",
  "#HomeBrandTagline": "ПРОСТРАНСТВО ДЛЯ ИДЕЙ",
  "#HomeChooseRoomType": "Выберите тип комнаты",
  "#HomeClearSearch": "Очистить поиск",
  "#HomeContinueAsGuest": "Продолжить как гость",
  "#HomeContinueWorking": "Продолжить работу",
  "#HomeCopying": "Создаём копию…",
  "#HomeCopyOriginal": "Создать копию исходного проекта",
  "#HomeCountInBrowser": "{0} в этом браузере",
  "#HomeCountInFolder": "{0} в папке «{1}»",
  "#HomeCover3D": "3D-вид",
  "#HomeCoverNew": "Новый интерьер",
  "#HomeCoverWalk": "Прогулка",
  "#HomeCreateFirstProject": "Создать первый проект",
  "#HomeCreateProject": "Создать проект",
  "#HomeCreating": "Создаём…",
  "#HomeDeleteForeverOneText": "«{0}» удалится без возможности восстановить. Сохранённые фото останутся в галерее.",
  "#HomeDeleteForeverSeveralText": "{0} удалятся без возможности восстановить. Сохранённые фото останутся в галерее.",
  "#HomeDeleteOneText": "«{0}» будет в «Недавно удалённых» {1} дней — оттуда его можно восстановить. Сохранённые фото останутся в галерее.",
  "#HomeDeleteProject": "Удалить проект?",
  "#HomeDeleteProjectForever": "Удалить проект навсегда?",
  "#HomeDeleteSelected": "Удалить выбранные проекты?",
  "#HomeDeleteSelectedForever": "Удалить выбранные проекты навсегда?",
  "#HomeDeleteSeveralText": "{0} будут в «Недавно удалённых» {1} дней — оттуда их можно восстановить. Сохранённые фото останутся в галерее.",
  "#HomeDropHint": "Стены, комнаты, двери и окна появятся сами",
  "#HomeDropToRecognize": "Отпустите, чтобы распознать план",
  "#HomeEmptyCaption": "Нарисуйте стены комнаты, затем добавьте мебель и материалы.",
  "#HomeFindInspiration": "Найти вдохновение",
  "#HomeFindProject": "Найти проект",
  "#HomeFinishSelecting": "Закончить выбор",
  "#HomeFirstStep": "Первый шаг к вашему дому",
  "#HomeFirstStepText": "Создайте план, расставьте мебель и посмотрите на интерьер в 3D.",
  "#HomeFolderCurrent": "Сейчас здесь",
  "#HomeFolderEmpty": "В папке пусто",
  "#HomeFolderEmptyText": "Проект попадёт сюда через «{0}» в меню его карточки.",
  "#HomeFooterTagline": "Продумано вами. Создано для жизни.",
  "#HomeGalleryAllProjects": "Все проекты",
  "#HomeGalleryAllShots": "Все кадры",
  "#HomeGalleryEmptyText": "Сделайте фото в 3D-редакторе — оно появится здесь. Все ваши фото и рендеры собраны в одной галерее.",
  "#HomeGalleryEmptyTitle": "Ваш интерьер. Лучший ракурс.",
  "#HomeGalleryFailed": "Не получилось",
  "#HomeGalleryGoToProjects": "Перейти к проектам",
  "#HomeGalleryImageFailed": "Не удалось создать изображение.",
  "#HomeGalleryImagePending": "Изображение ещё готовится. Вернитесь в проект, чтобы проверить результат.",
  "#HomeGalleryImageUnavailable": "Изображение недоступно.",
  "#HomeGalleryKindLabel": "Тип изображения",
  "#HomeGalleryLoading": "Открываем галерею…",
  "#HomeGalleryNoMatches": "Нет кадров с такими фильтрами",
  "#HomeGalleryNoMatchesText": "Выберите другой проект или тип изображения.",
  "#HomeGalleryOpenOriginal": "Открыть оригинал",
  "#HomeGalleryOpenProject": "Открыть проект",
  "#HomeGalleryPhoto": "Фото",
  "#HomeGalleryPhotoAlt": "Фото интерьера",
  "#HomeGalleryPhotos": "Фото",
  "#HomeGalleryPreparing": "Готовится…",
  "#HomeGalleryPreviewAlt": "Просмотр кадра интерьера",
  "#HomeGalleryProjectFallback": "Проект {0}",
  "#HomeGalleryProjectLabel": "Проект в галерее",
  "#HomeGalleryRender": "Рендер",
  "#HomeGalleryRenderAlt": "Рендер интерьера",
  "#HomeGalleryRenders": "Рендеры",
  "#HomeGalleryResetFilters": "Сбросить фильтры",
  "#HomeGalleryRestoreAndOpen": "Восстановить и открыть",
  "#HomeGuestProfile": "Гостевой профиль",
  "#HomeGuestProfileSignIn": "Гостевой профиль — войти в аккаунт",
  "#HomeHeadline": "Место, где начинается дом",
  "#HomeHeroAlt": "Светлая гостиная с природными материалами и мягкой мебелью",
  "#HomeHeroCaption": "Органический модерн · Home Planner",
  "#HomeHeroEyebrow": "ВДОХНОВЕНИЕ РЯДОМ",
  "#HomeHeroText": "Найдите стиль, который близок вам.{0}И сделайте его своим.",
  "#HomeHeroTitle": "Дом начинается{0}с ощущения.",
  "#HomeIdeaFeed": "Лента идей",
  "#HomeIdeasHint": "Подборка стилей Home Planner",
  "#HomeIdeasTitle": "Идеи для вашего дома",
  "#HomeImageFailed": "Изображение не загрузилось",
  "#HomeImageRetry": "Повторить загрузку",
  "#HomeLinkBannerText": "Откройте проект по общей ссылке и продолжите в браузере.",
  "#HomeLinkBannerTitle": "Уже начали в Home Planner?",
  "#HomeLinkField": "Ссылка из Home Planner",
  "#HomeLocalNoteText": "Проекты и фото сохраняются{0}в этом браузере.",
  "#HomeLocalNoteTitle": "Ваше личное пространство",
  "#HomeMainNavigation": "Основная навигация",
  "#HomeMakeLocalCopy": "Создать локальную копию",
  "#HomeMoveButton": "Переместить",
  "#HomeMoveToFolder": "Переместить в папку",
  "#HomeMyProjects": "Мои проекты",
  "#HomeNewCardHint": "Место для следующей идеи",
  "#HomeNewProject": "Новый проект",
  "#HomeNewProjectName": "Мой интерьер {0}",
  "#HomeNoProjectFound": "Проект не найден",
  "#HomeNoProjectFoundHint": "Попробуйте другое название или очистите поиск.",
  "#HomeOpenByLink": "Открыть по ссылке",
  "#HomeOpenProject": "Открыть {0}",
  "#HomePasteProjectLink": "Вставьте ссылку на проект Home Planner.",
  "#HomePlanBannerText": "Загрузите фото или картинку плана — стены, комнаты, двери и окна появятся сами, и проект откроется в 3D.",
  "#HomePlanBannerTitle": "Есть план квартиры?",
  "#HomeProjectActions": "Действия с проектом {0}",
  "#HomeProjectCountFew": "{0} проекта",
  "#HomeProjectCountMany": "{0} проектов",
  "#HomeProjectCountOne": "{0} проект",
  "#HomeProjectFolders": "Папки проектов",
  "#HomeProjectMovedTo": "Проект перемещён в папку «{0}»",
  "#HomeProjectName": "Название проекта",
  "#HomeProjectRestoredTo": "Проект восстановлен в папку «{0}»",
  "#HomeProjectsMovedTo": "Проекты перемещены в папку «{0}»",
  "#HomeProjectsRestored": "Проекты восстановлены",
  "#HomeReadProjectsFailed": "Не удалось прочитать проекты в этом браузере.",
  "#HomeReadyProjects": "Готовые проекты",
  "#HomeReadyProjectsHint": "Откройте пример и попробуйте редактор — настраивать ничего не нужно",
  "#HomeReadyProjectsOwn": "Примеры Home Planner — открываются и редактируются как ваши собственные",
  "#HomeRestoreOrDeleteProject": "Восстановить или удалить {0}",
  "#HomeRoomShapeFailed": "Не удалось загрузить форму комнаты. Проверьте соединение и попробуйте ещё раз.",
  "#HomeSaveFailed": "Не удалось сохранить изменения. Проверьте свободное место и доступ к хранилищу браузера.",
  "#HomeSearchProjects": "Поиск проектов",
  "#HomeSelectedCount": "Выбрано: {0}",
  "#HomeSelectedProjects": "Выбранные проекты",
  "#HomeSelectProject": "Выбрать {0}",
  "#HomeSelectProjects": "Выберите проекты",
  "#HomeShapeCaption": "Комната с дверью, окнами, отделкой и светильником; форму и размеры можно поменять позже.",
  "#HomeShapeFromScratch": "С нуля",
  "#HomeShapeFromScratchHint": "Рисовать стены с нуля",
  "#HomeSharedNotManaged": "Совместный проект не удаляется и не перемещается отсюда",
  "#HomeSharedProject": "Совместный проект",
  "#HomeSignedIn": "Вы вошли",
  "#HomeSignedInText": "Вы вошли в аккаунт Home Planner. Проекты и галерея по-прежнему хранятся в этом браузере.",
  "#HomeSignInFailed": "Не удалось войти. Попробуйте ещё раз.",
  "#HomeSignInNote": "Откроется сервис входа. Перенос и синхронизация локальных проектов пока не подключены.",
  "#HomeSignInToAccount": "Войти в аккаунт",
  "#HomeSkipToContent": "К содержимому",
  "#HomeSortArea": "По площади",
  "#HomeSortName": "По названию",
  "#HomeSortProjects": "Сортировка проектов",
  "#HomeSortRecent": "Сначала недавние",
  "#HomeStartFromLink": "Начать с проекта по ссылке",
  "#HomeStartFromPlan": "Начать с плана квартиры: фото или картинки",
  "#HomeSubtitleFeed": "Находите детали, из которых сложится ваш интерьер.",
  "#HomeSubtitleGallery": "Фото и рендеры ваших интерьеров в одном месте.",
  "#HomeSubtitleHome": "Создавайте интерьеры, в которых хочется жить.",
  "#HomeSubtitleProjects": "От первой идеи до последней детали — всё здесь.",
  "#HomeTab": "Главная",
  "#HomeTrashCount": "{0} · хранятся {1} дней, потом удаляются навсегда",
  "#HomeTrashedText": "{0} до удаления навсегда. Восстановите проект, чтобы открыть его снова.",
  "#HomeTrashEmpty": "Здесь пусто",
  "#HomeTrashEmptyText": "Удалённые проекты хранятся здесь {0} дней — за это время их можно восстановить.",
  "#HomeViewGrid": "Плитка",
  "#HomeViewList": "Список",
  "#HomeWholeFeed": "Вся лента",
  "#HomeYourSpace": "Ваше пространство",
  "#InspirationAllStyles": "Все стили",
  "#InspirationBedroomText": "Спокойный свет и удобная расстановка делают спальню местом отдыха. Оставьте проходы по сторонам кровати и добавьте отдельный свет для чтения.",
  "#InspirationBedroomTitle": "Личное место тишины",
  "#InspirationContemporaryText": "Чёткие линии, мягкая мебель и акценты, которые задают характер. Начните с расстановки крупных предметов и проверьте, насколько удобно проходить между ними.",
  "#InspirationContemporaryTitle": "Современный ритм",
  "#InspirationCreateOwn": "Создать свой интерьер",
  "#InspirationEmptyText": "Попробуйте другой стиль или посмотрите все идеи.",
  "#InspirationEmptyTitle": "Пока нет такой подборки",
  "#InspirationIllustrationNote": "Иллюстрация стиля из каталога Home Planner. Создайте свой проект с чистого листа.",
  "#InspirationImageAlt": "{0}: интерьер",
  "#InspirationMidCenturyText": "Тёплое дерево, выразительная геометрия и мебель на тонких ножках. Сочетайте спокойную основу с одним насыщенным цветом и повторите его в деталях.",
  "#InspirationMidCenturyTitle": "Характер вне времени",
  "#InspirationOrganicText": "Мягкие силуэты, дерево и естественные оттенки. Оставьте больше свободного пространства вокруг дивана, а тёплый свет добавьте на нескольких уровнях.",
  "#InspirationOrganicTitle": "Ближе к природе",
  "#InspirationPicks": "Подборка Home Planner",
  "#InspirationPicksDetail": "— материалы и стили из нашего каталога",
  "#InspirationStyleLabel": "Стиль интерьера",
  "#InspirationStyleOrganicModern": "Органический модерн",
  "#InspirationWabiSabiText": "Спокойная палитра и выразительные природные фактуры. Соберите интерьер вокруг нескольких предметов: мягкого дивана, лаконичного светильника и текстиля с заметным плетением.",
  "#InspirationWabiSabiTitle": "Красота простых вещей",
  "#InteriorStyleAfricanName": "Африканский",
  "#InteriorStyleArabicName": "Арабский",
  "#InteriorStyleArtDecoName": "Ар-деко",
  "#InteriorStyleAsianContemporaryName": "Азиатский",
  "#InteriorStyleBarbieName": "Барби",
  "#InteriorStyleBauhausName": "Баухаус",
  "#InteriorStyleBohoName": "Бохо",
  "#InteriorStyleBrutalismName": "Брутализм",
  "#InteriorStyleChaletName": "Шале",
  "#InteriorStyleCoastalName": "Прибрежный",
  "#InteriorStyleContemporaryClassicalName": "Современная классика",
  "#InteriorStyleContemporaryName": "Современный",
  "#InteriorStyleCountryStyleName": "Кантри",
  "#InteriorStyleCraftsmanName": "Ремесленный",
  "#InteriorStyleEclecticName": "Эклектика",
  "#InteriorStyleEnglishName": "Английский",
  "#InteriorStyleFarmhouseName": "Фармхаус",
  "#InteriorStyleFrenchCountryProvenceName": "Прованс",
  "#InteriorStyleGlamName": "Гламур",
  "#InteriorStyleGreekName": "Греческий",
  "#InteriorStyleIndianName": "Индийский",
  "#InteriorStyleIndustrialName": "Лофт",
  "#InteriorStyleJapandiName": "Джапанди",
  "#InteriorStyleMaximalismName": "Максимализм",
  "#InteriorStyleMediterraneanName": "Средиземноморский",
  "#InteriorStyleMemphisName": "Мемфис",
  "#InteriorStyleMidcenturyName": "Мидсенчури",
  "#InteriorStyleMinimalistName": "Минимализм",
  "#InteriorStyleNeoclassicName": "Неоклассика",
  "#InteriorStyleOrganicModernName": "Органик модерн",
  "#InteriorStyleQuietLuxuryName": "Тихая роскошь",
  "#InteriorStyleRetro1970sName": "Ретро 1970-х",
  "#InteriorStyleRetrofuturisticName": "Ретрофутуризм",
  "#InteriorStyleRusticName": "Рустик",
  "#InteriorStyleScandinavianName": "Скандинавский",
  "#InteriorStyleShabbyChicName": "Шебби-шик",
  "#InteriorStyleSouthwesternName": "Юго-западный",
  "#InteriorStyleSpanishRevivalName": "Испанское возрождение",
  "#InteriorStyleTraditionalName": "Традиционный",
  "#InteriorStyleTropicalName": "Тропический",
  "#InteriorStyleVictorianName": "Викторианский",
  "#InteriorStyleVintageName": "Винтаж",
  "#InteriorStyleWabiSabiName": "Вабисаби",
  "#InternetConnectionUnstable": "Нестабильное интернет-соединение",
  "#InviteNormal": "Пригласить",
  "#InviteProjectUnreadable": "Файл этого проекта не получается прочитать. Сообщите об этом владельцу.",
  "#ItemPropsBadBaseScale": "Не удалось изменить размер: исходный масштаб предмета некорректен.",
  "#ItemPropsCantApplySize": "Не удалось применить такой размер предмета.",
  "#ItemPropsCheckPosition": "Проверьте положение предмета.",
  "#ItemPropsSizeMustBePositive": "Размеры предмета должны быть больше нуля.",
  "#LabelsAndAnnotations": "Метки и аннотации",
  "#LeaveProject": "Покинуть проект",
  "#LeaveProjectConfirm": "Ты потеряешь доступ к проекту и не сможешь в него зайти.",
  "#LeaveTeamWriteSupport": "Написать в поддержку",
  "#LibraryCopyName": "{0} · копия",
  "#LibraryDefaultName": "Мой интерьер",
  "#LibraryGalleryReadFailed": "Не удалось прочитать галерею. Проверьте доступ к хранилищу браузера и обновите страницу.",
  "#LibraryProjectNotFound": "Проект не найден.",
  "#LinkUnavailable": "В проект больше нельзя войти.",
  "#LinkUnavailableTitle": "Проект больше недоступен",
  "#LivingArea": "Жилая площадь",
  "#LoadingText": "Загрузка",
  "#LowerLevel": "Подвал {0}",
  "#MainDimensions": "Основные размеры",
  "#MakePhoto": "Сделать фото",
  "#MaterialContextFromProject": "Из проекта",
  "#MaterialContextProjectMaterial": "Материал проекта",
  "#MaterialPickerApplied": "Применено: {0}",
  "#MaterialPickerApplyAll": "Ко всем ({0})",
  "#MaterialPickerApplyFailed": "Не удалось получить материал. Нажмите ещё раз.",
  "#MaterialPickerApplyToRoomWalls": "Применить ко всем стенам комнаты",
  "#MaterialPickerCatalogFailed": "Не удалось загрузить материалы из каталога.",
  "#MaterialPickerCategoryEmpty": "В этой категории пока нет материалов.",
  "#MaterialPickerClose": "Закрыть материалы",
  "#MaterialPickerFieldCm": "{0}, см",
  "#MaterialPickerFieldValue": "{0}, значение",
  "#MaterialPickerLoadFailed": "Не удалось загрузить материалы.",
  "#MaterialPickerLoading": "Загружаем материалы…",
  "#MaterialPickerModelColour": "Цвет модели",
  "#MaterialPickerModelPart": "Часть модели",
  "#MaterialPickerNotPreparedLabel": "{0}, ещё не подготовлен",
  "#MaterialPickerNotPreparedTitle": "{0} · ещё не подготовлен",
  "#MaterialPickerRecentEmpty": "Здесь появятся выбранные материалы.",
  "#MaterialPickerScaleRotation": "Масштаб и поворот",
  "#MaterialPickerShowMore": "Показать ещё",
  "#MaterialPickerTextureRotation": "Поворот текстуры",
  "#MaterialPickerTileHeight": "Высота плитки",
  "#MaterialPickerTileLength": "Длина плитки",
  "#MaterialPickerTileSize": "Размер плитки",
  "#MaterialPickerTileWidth": "Ширина плитки",
  "#MaterialPickerWholeDoor": "Вся дверь",
  "#MaterialPickerWholeItem": "Весь предмет",
  "#MaterialPickerWholeOpening": "Весь проём",
  "#MaterialPickerWholeWindow": "Всё окно",
  "#MaterialsDefinitionHttpError": "Описание материала: HTTP {0}",
  "#MaterialsNotPrepared": "Этот материал ещё не подготовлен для веб-редактора.",
  "#Message": "Сообщение",
  "#Minimap": "Миникарта",
  "#MinimapChooseFloor": "Выберите другой этаж.",
  "#MinimapClose": "Закрыть миникарту",
  "#MinimapFloorPlan": "План этажа",
  "#MinimapHideOthers": "Скрыть остальные комнаты",
  "#MinimapHint": "Нажмите на комнату, чтобы перейти в неё.",
  "#MinimapNoRooms": "На этом этаже нет комнат.",
  "#ModelVariationsGlossBlack": "Черный глянец",
  "#ModelVariationsVariant": "Вариант {0}",
  "#ModelVariationsWalnut": "Под грецкий орех",
  "#ModelVariationsWhiteBlack": "Бело-черный",
  "#MoveWallHint": "Передвинь стену, чтобы изменить размер комнаты",
  "#NoCurtains": "Без штор",
  "#NoFinishWall": "Без отделки",
  "#OnlyInvitedPeople": "Только приглашённые",
  "#OpeningPropsCheckWidth": "Проверьте ширину проёма.",
  "#OpeningPropsChooseSashForOpening": "Для открывания выберите тип створки.",
  "#OpeningPropsCurtainsWindowsOnly": "Шторы доступны только для окон.",
  "#OpeningPropsNoRoomToResize": "На стене нет места для изменения ширины.",
  "#OpeningPropsOpenAngleRange": "Угол открывания должен быть от 0 до {0}°.",
  "#OpeningPropsRecessRange": "Углубление должно быть от 0 до толщины стены.",
  "#OpeningPropsSashDoesNotFit": "Этот тип створки не подходит для выбранного проёма.",
  "#OpeningSharedProject": "Открытие общего проекта",
  "#Other": "Другое",
  "#OtherAccountOpenVisit": "Только просмотр",
  "#OtherItem": "Другое",
  "#OtherStyleName": "Переходный",
  "#PartitionsAndZoning": "Перегородки и зонирование",
  "#Perimeter": "Периметр",
  "#PermissionsChanged": "Права изменены",
  "#Photo": "Фото",
  "#PlanConstructionMoveToFreeSpot": "Перенесите проём на свободное место стены.",
  "#PlanConstructionNoFreeSpot": "На стене нет свободного места для этого проёма.",
  "#PlanConstructionRoomTooSmall": "Задайте ширину и глубину комнаты не меньше 20 см.",
  "#PlanExportArchitect": "Архитектурный план этажа",
  "#PlanExportArchitectDetail": "Для проекта дизайна интерьера: черно-белый план с размерами каждой стены.",
  "#PlanExportArchitectFile": "архитектурный",
  "#PlanExportClose": "Закрыть экспорт плана",
  "#PlanExportColour": "Полноцветный план",
  "#PlanExportColourDetail": "Всё как на экране: цвета пола, мебель и размеры, если они включены.",
  "#PlanExportColourFile": "цветной",
  "#PlanExportDefaultName": "План",
  "#PlanExportDrawFailed": "Не удалось нарисовать план. Попробуйте ещё раз.",
  "#PlanExportFurniture": "План этажа с мебелью",
  "#PlanExportFurnitureDetail": "Черно-белый план для описания недвижимости: комнаты и расположение мебели.",
  "#PlanExportFurnitureFile": "с мебелью",
  "#PlanExportNote": "{0}: картинка PNG сохранится на этом устройстве.",
  "#PlanExportPreparing": "Готовим…",
  "#PlanExportSaveFailed": "Не удалось сохранить план. Попробуйте ещё раз.",
  "#PlanGestureCopyIdTaken": "Идентификатор копии уже занят.",
  "#PlanScaleEnterArea": "Введите площадь от 0.1 м².",
  "#PlanScaleEnterLength": "Введите длину от 0.1 м.",
  "#PlanScaleSizeUnusable": "Размер нельзя взять за основу масштаба.",
  "#PlanScaleTooFar": "Такой масштаб слишком далёк от плана.",
  "#PositionAndRotation": "Положение и вращение",
  "#ProjectWillRefreshOnReconnect": "Дизайн обновится сам, как только связь восстановится",
  "#PromoteToEditor": "Повысить до редактора",
  "#Properties": "Свойства",
  "#PropertyEditMoldingNotFound": "Молдинг не найден.",
  "#PropertyEditPlinthNotFound": "Плинтус не найден.",
  "#PropertyEditTrimHeightRange": "Высота: введите число от {0} до {1}.",
  "#PropsAppliedToFew": "Применено к {0} предметам",
  "#PropsAppliedToMany": "Применено к {0} предметам",
  "#PropsAppliedToOne": "Применено к {0} предмету",
  "#PropsArchOrOpening": "Арка / проём",
  "#PropsAttic": "Мансарда",
  "#PropsAtticHint": "Колено — высота, с которой начинается скат; уклон — его наклон к полу.",
  "#PropsAtticNote": "Уклон {0}. Скат уходит в комнату на {1} м, его длина {2} м.",
  "#PropsAtticWindowInSlope": "Окно лежит в скате: {0} м по скату. С низом ниже {1} м от пола оно встанет в стену, а скат над ним откроется нишей.",
  "#PropsAtticWindowInWall": "Окно стоит в стене, а в скате над ним — ниша, как у слухового окна. С низом от {0} м от пола окно ляжет в скат.",
  "#PropsBackSide": "Обратная сторона",
  "#PropsBackToParameters": "Назад к параметрам",
  "#PropsCatalogModel": "Модель из каталога",
  "#PropsCeilingMolding": "Потолочный молдинг",
  "#PropsCenterAlongWall": "Центр по стене",
  "#PropsCenterFromWallStart": "Центр от начала стены",
  "#PropsCheckSizes": "Проверьте размеры.",
  "#PropsChooseCurtainsInCatalog": "Выберите шторы в каталоге",
  "#PropsChooseTypeBelow": "Выберите тип конструкции ниже",
  "#PropsCloseInspector": "Закрыть параметры предмета",
  "#PropsCoordinateX": "Координата X",
  "#PropsCoordinateY": "Координата Y",
  "#PropsCurrentFinish": "Текущая отделка",
  "#PropsCurtainsDrapes": "Портьеры",
  "#PropsCurtainsLabel": "Шторы: {0}. Выбрать шторы",
  "#PropsCurtainsRoller": "Рулонные шторы",
  "#PropsCurtainsSheer": "Тюль",
  "#PropsCustomDesign": "Настраиваемая конструкция",
  "#PropsDeleteDoor": "Удалить дверь",
  "#PropsDeleteWindow": "Удалить окно",
  "#PropsDistanceFromFloor": "Расстояние от пола",
  "#PropsDoorAngleNote": "Для настройки угла выберите тип двери. Исходная модель сохраняет своё положение.",
  "#PropsDoorDesign": "Конструкция двери",
  "#PropsDoorDouble": "Двустворчатая",
  "#PropsDoorFlush": "Гладкая",
  "#PropsDoorGlazed": "Со стеклом",
  "#PropsDrawnCurtains": "Простые шторы редактора",
  "#PropsEditMaterial": "Изменить материал",
  "#PropsEndX": "Конец X",
  "#PropsEndY": "Конец Y",
  "#PropsEnterNumber": "{0}: введите число от {1} до {2}.",
  "#PropsExactCoordinates": "Точные координаты",
  "#PropsFromFloor": "От пола",
  "#PropsFromMeters": "от {0} м",
  "#PropsFrontSide": "Лицевая сторона",
  "#PropsHingeOriginal": "Исходная",
  "#PropsHingeReversed": "Обратная",
  "#PropsHingeSide": "Сторона петель",
  "#PropsItemActions": "Действия с предметом",
  "#PropsItemProperties": "Параметры предмета",
  "#PropsKnee": "Колено",
  "#PropsKneeFromFloor": "Колено, от пола",
  "#PropsLayWindowInSlope": "Уложить окно в скат",
  "#PropsModel": "Модель",
  "#PropsModelNamed": "Модель: {0}",
  "#PropsMoldingActions": "Действия с молдингом",
  "#PropsMoldingHeightNote": "Высота меняется у всех молдингов комнаты, как в приложении.",
  "#PropsNoModelChooseType": "Без модели — выберите тип",
  "#PropsObjectMaterials": "Материалы объекта",
  "#PropsOpenAngle": "Угол открывания",
  "#PropsOpeningActions": "Действия с проёмом",
  "#PropsOpeningReplacementNote": "Замена: {0}. Размер и положение проёма сохраняются.",
  "#PropsOpenModelCatalog": "Открыть каталог моделей",
  "#PropsOriginalModel": "Исходная модель",
  "#PropsPitch": "Уклон",
  "#PropsPlinthActions": "Действия с плинтусом",
  "#PropsPlinthHeightNote": "Высота меняется у всех плинтусов комнаты, как в приложении.",
  "#PropsPositionInWall": "Положение в стене",
  "#PropsProjectModel": "Исходная модель проекта",
  "#PropsRecess": "Углубление",
  "#PropsRecessNote": "Углубление: от внутренней поверхности стены к внешней.",
  "#PropsReplaceAllTitle": "Заменить и все такие же предметы в этой комнате",
  "#PropsReplaceFailed": "Не удалось заменить предметы.",
  "#PropsReplacementNote": "Замена: {0}. Размеры можно настроить перед применением.",
  "#PropsReset": "Сбросить",
  "#PropsResetSection": "Сбросить: {0}",
  "#PropsRoom": "Помещение",
  "#PropsRoomSizeNote": "По полу, внутри стен, как в приложении. Ширина и длина двигают одну сторону, площадь меняет помещение целиком, стены утолщаются наружу, высота потолка — у всего этажа.",
  "#PropsRoomSurface": "Поверхность помещения",
  "#PropsRotation": "Поворот",
  "#PropsSliderLabel": "{0}, ползунок",
  "#PropsSlope": "Скат",
  "#PropsStartX": "Начало X",
  "#PropsStartY": "Начало Y",
  "#PropsSurfaceColor": "Цвет поверхности",
  "#PropsTextureAndColor": "Текстура и цвет",
  "#PropsWallActions": "Действия со стеной",
  "#PropsWallEndCoordinates": "Координаты концов стены",
  "#PropsWallLengthNote": "Длина меняется от начальной точки. Примыкающие стены перемещаются вместе с концами.",
  "#PropsWallSide": "Сторона стены",
  "#PropsWallsThicknessMixed": "Толщина стен · сейчас разная",
  "#PropsWholeDoor": "Вся дверь",
  "#PropsWholeItem": "Весь предмет",
  "#PropsWholeOpening": "Весь проём",
  "#PropsWholeWindow": "Всё окно",
  "#PropsWindowDesign": "Конструкция окна",
  "#PropsWindowDouble": "Двустворчатое",
  "#PropsWindowSingle": "Одностворчатое",
  "#PropsWindowTriple": "Трёхстворчатое",
  "#PurchaseRetryLoad": "Повторить",
  "#Quality": "Качество",
  "#RecognitionAddFloor": "Добавить этаж",
  "#RecognitionAnotherFloorDrop": "Ещё этаж — перетащите сюда или",
  "#RecognitionApartmentPlanName": "План квартиры",
  "#RecognitionBadImageText": "Кажется, файл повреждён. Выберите другое изображение.",
  "#RecognitionBadImageTitle": "Изображение не читается",
  "#RecognitionBusyText": "Сейчас распознаётся много планов. Попробуйте через минуту.",
  "#RecognitionBusyTitle": "Сервис распознавания занят",
  "#RecognitionCancelledText": "Загрузите план ещё раз, когда будете готовы.",
  "#RecognitionCancelledTitle": "Распознавание остановлено",
  "#RecognitionCheckAdvice": "Распознавание может ошибаться: сверьте размеры и при необходимости поправьте стены, окна и двери.",
  "#RecognitionChooseFile": "Выбрать файл",
  "#RecognitionChosenPlan": "Выбранный план",
  "#RecognitionCleaningImage": "уточняем изображение",
  "#RecognitionDemoNote": "Демонстрация: сервис распознавания ещё подключается. Вместо вашего плана откроется готовый дом.",
  "#RecognitionDrawWallsManually": "Нарисовать стены вручную",
  "#RecognitionDropFormats": "JPG, PNG, WebP или HEIC · один этаж на изображение · до {0}",
  "#RecognitionDropHere": "Перетащите план сюда",
  "#RecognitionElapsed": "Прошло {0}",
  "#RecognitionFileTooLarge": "Больше {0} МБ",
  "#RecognitionFileUnreadable": "Не удалось прочитать изображение",
  "#RecognitionFileUnsupported": "Формат не подходит — нужен JPG или PNG",
  "#RecognitionFloorCountFew": "{0} этажа",
  "#RecognitionFloorCountMany": "{0} этажей",
  "#RecognitionFloorCountOne": "{0} этаж",
  "#RecognitionFloorNotRecognized": "этаж {0} — план не распознан",
  "#RecognitionFloorNumber": "Этаж {0}",
  "#RecognitionFloorOfFloors": "этаж {0} из {1}",
  "#RecognitionFloorOrderLabel": "Порядок этажей: верхний этаж сверху",
  "#RecognitionFloorScaleNotMatched": "этаж {0} — масштаб не сведён с нижним этажом",
  "#RecognitionFloorTimedOut": "этаж {0} — не дождались распознавания",
  "#RecognitionHintDemo": "в демонстрации это около десяти секунд",
  "#RecognitionHintLong": "большой план или много желающих — подождите ещё",
  "#RecognitionHintUsual": "обычно до минуты, проект откроется сам",
  "#RecognitionHousePlanName": "План дома",
  "#RecognitionKeepWaiting": "Ждать дальше",
  "#RecognitionLead": "Фото, скан или скриншот плана — стены, комнаты, двери и окна появятся сами, и проект откроется в 3D.",
  "#RecognitionModelsProgress": "модели {0} из {1}",
  "#RecognitionMoveFloorDown": "Этаж {0}: опустить ниже",
  "#RecognitionMoveFloorUp": "Этаж {0}: поднять выше",
  "#RecognitionMyInterior": "Мой интерьер",
  "#RecognitionNetworkText": "Проверьте подключение к интернету или повторите попытку позже.",
  "#RecognitionNetworkTitle": "Нет связи",
  "#RecognitionNoMoreFloors": "Больше {0} не загрузить",
  "#RecognitionNotRecognizedText": "На изображении не нашлось стен, из которых складываются комнаты. Попробуйте другое изображение — ровное, без бликов, с планом целиком в кадре — или нарисуйте стены вручную.",
  "#RecognitionNotRecognizedTitle": "План не распознан",
  "#RecognitionOverflow": "За раз можно загрузить не больше {0} планов — лишние не добавлены.",
  "#RecognitionPlan": "План",
  "#RecognitionProgressLabel": "Распознавание плана",
  "#RecognitionQueuePosition": "в очереди, перед вами {0}",
  "#RecognitionReadingImage": "Читаем изображение…",
  "#RecognitionReadingImages": "Читаем изображения…",
  "#RecognitionRecognizeFloors": "Распознать {0}",
  "#RecognitionRecognizePlan": "Распознать план",
  "#RecognitionRecognizingPlan": "Распознаём план",
  "#RecognitionRemoveFailed": "Уберите изображения, которые не открылись, или замените их.",
  "#RecognitionRemovePlan": "Убрать {0}",
  "#RecognitionServerText": "Сервис распознавания ответил ошибкой. Попробуйте ещё раз, а если не выйдет — загрузите другое изображение.",
  "#RecognitionServerTitle": "Не получилось распознать",
  "#RecognitionSizeKilobytes": "{0} КБ",
  "#RecognitionSizeMegabytes": "{0} МБ",
  "#RecognitionStartingSoon": "сейчас начнём",
  "#RecognitionStepActive": "— сейчас",
  "#RecognitionStepAssembling": "Собираем комнаты",
  "#RecognitionStepDone": "— готово",
  "#RecognitionStepOpening": "Открываем в 3D",
  "#RecognitionStepRecognizing": "Распознаём стены, двери и окна",
  "#RecognitionStepUploading": "Загружаем план",
  "#RecognitionStopQuestion": "Остановить распознавание?",
  "#RecognitionStopWarning": "План придётся загрузить заново.",
  "#RecognitionStorageText": "Браузер не сохранил проект: в его хранилище закончилось место. Удалите ненужные проекты и попробуйте снова.",
  "#RecognitionStorageTitle": "Не хватило места",
  "#RecognitionTakePhoto": "Сфотографировать",
  "#RecognitionTimedOutTitle": "Не дождались распознавания",
  "#RecognitionTipPhotoScanScreenshot": "Подойдёт фото, скан или скриншот",
  "#RecognitionTipRoomLabels": "Подписи комнат дают комнатам названия",
  "#RecognitionTipSharperImage": "Чем чётче изображение, тем точнее план",
  "#RecognitionTipSizesDoorsWindows": "Размеры, двери и окна на плане помогают распознаванию",
  "#RecognitionTooLargeText": "Выберите изображение до {0} МБ.",
  "#RecognitionTooLargeTitle": "Изображение слишком большое",
  "#RecognitionTooManyText": "За раз можно загрузить не больше {0} планов — по одному на этаж.",
  "#RecognitionTooManyTitle": "Слишком много планов",
  "#RecognitionUnsupportedText": "Сохраните план как картинку JPG или PNG и загрузите её.",
  "#RecognitionUnsupportedTitle": "Этот формат не подходит",
  "#RemoveAccess": "Закрыть доступ",
  "#RemoveWall": "Удалить стену",
  "#RenderResumeGaveUp": "Сервер так и не вернул рендер за полчаса",
  "#RenderResumeNeverSent": "Рендер не был отправлен на сервер",
  "#RoofLevelTitle": "Крыша",
  "#RoomAll": "Комната",
  "#RoomBabyKids": "Детская",
  "#RoomBabyKidsManyMy": "Мои детские",
  "#RoomBath": "Ванная",
  "#RoomBathManyMy": "Мои ванные",
  "#RoomBedroom": "Спальня",
  "#RoomBedroomManyMy": "Мои спальни",
  "#RoomCafe": "Кафе и бар",
  "#RoomCafeManyMy": "Мои кафе и бары",
  "#RoomCloset": "Гардеробная",
  "#RoomClosetManyMy": "Мои гардеробные",
  "#RoomCoworking": "Офис",
  "#RoomCoworkingManyMy": "Мои офисы",
  "#RoomDining": "Столовая",
  "#RoomDiningManyMy": "Мои столовые",
  "#RoomEvent": "Зал для мероприятий",
  "#RoomEventManyMy": "Мои залы для мероприятий",
  "#RoomFloorplan": "План помещения",
  "#RoomFloorplanManyMy": "Мои планы помещений",
  "#RoomGarage": "Гараж",
  "#RoomGarageManyMy": "Мои гаражи",
  "#RoomGym": "Спортзал",
  "#RoomGymManyMy": "Мои спортзалы",
  "#RoomHall": "Прихожая",
  "#RoomHallManyMy": "Мои прихожие",
  "#RoomHomeCinema": "Домашний кинотеатр",
  "#RoomHomeCinemaManyMy": "Мои домашние кинотеатры",
  "#RoomHomeOffice": "Кабинет",
  "#RoomHomeOfficeManyMy": "Мои кабинеты",
  "#RoomIsFullDesc": "В комнате уже максимальное количество участников.",
  "#RoomIsFullTitle": "Комната заполнена",
  "#RoomKitchen": "Кухня",
  "#RoomKitchenManyMy": "Мои кухни",
  "#RoomLaundry": "Прачечная",
  "#RoomLaundryManyMy": "Мои прачечные",
  "#RoomLiving": "Гостиная",
  "#RoomLivingManyMy": "Мои гостиные",
  "#RoomName": "Название комнаты",
  "#RoomOutdoor": "Двор или терраса",
  "#RoomOutdoorManyMy": "Двор или терраса",
  "#RoomReception": "Приемная",
  "#RoomReceptionManyMy": "Мои приемные",
  "#Rooms": "Комнаты",
  "#RoomSalon": "Салон красоты",
  "#RoomSalonManyMy": "Мои салоны красоты",
  "#RoomShapeBayWindow2": "Т-образная",
  "#RoomShapeCorner1": "Г-образная",
  "#RoomShapeCorner2": "Срезанный угол",
  "#RoomShapeRectangular": "Прямоугольная",
  "#RoomShapesRounded": "Скруглённая",
  "#RoomShapeTitle": "Форма комнаты",
  "#RoomShapeZshape": "Z-образная",
  "#RoomSizeAreaBlocked": "Не получилось изменить площадь помещения: мешают соседние стены.",
  "#RoomSizeAreaFailed": "Не получилось изменить площадь помещения.",
  "#RoomSizeAreaRange": "Площадь: от {0} до {1}.",
  "#RoomSizeCeilingHeightRange": "Высота потолка: от {0} до {1}.",
  "#RoomSizeLengthRange": "Длина: от {0} до {1}.",
  "#RoomSizeNoArea": "У помещения нет площади.",
  "#RoomSizeNoWalls": "У помещения нет стен.",
  "#RoomSizeOpeningDoesNotFitHeight": "Проём не помещается в стену высотой {0} м.",
  "#RoomSizeRoomNotFound": "Помещение не найдено.",
  "#RoomSizeSideBlocked": "Не получилось изменить размер помещения: мешают соседние стены.",
  "#RoomSizeThicknessFailed": "Не получилось изменить толщину стен.",
  "#RoomSizeWallThicknessRange": "Толщина стен: от {0} до {1}.",
  "#RoomSizeWidthRange": "Ширина: от {0} до {1}.",
  "#RoomStore": "Магазин",
  "#RoomStoreManyMy": "Мои магазины",
  "#RoomType": "Тип комнаты",
  "#RoomTypeText": "Выбери тип комнаты",
  "#SearchByNameOrEmail": "Добавь людей по имени или email",
  "#SelectAll": "Выбрать все",
  "#ShareCopyFailed": "Не удалось скопировать автоматически. Ссылка: {0}",
  "#ShareDemoNotice": "Это пример: в проекте боты-агенты. Нажмите на аватар в шапке, чтобы увидеть проект их глазами.",
  "#ShareRemoveBots": "Убрать ботов",
  "#ShareShowDemo": "Показать пример с ботами-агентами",
  "#ShareUnavailable": "Совместная работа пока недоступна: подключение сервиса ещё готовится. Вы можете продолжать редактировать проект в этом браузере.",
  "#ShareYou": "Вы",
  "#ShareYouMark": "(вы)",
  "#SharingUpdateFailed": "Не удалось обновить настройки доступа. Попробуй ещё раз.",
  "#ShoppingList": "Список покупок",
  "#ShowAllRooms": "Показать все комнаты",
  "#ShowMore": "Ещё",
  "#ShowWall": "Показать стену",
  "#SomethingWentWrong": "Что-то пошло не так",
  "#SplitWall": "Разделить стену",
  "#StairsAndPodiums": "Лестницы и подиумы",
  "#Statistics": "Статистика",
  "#StatisticsFinishCustomImage": "Своё изображение",
  "#StatisticsFinishSlope": "Скат",
  "#StatisticsRoomNameWithArea": "{0} ({1} м²)",
  "#StatsDialogAnsiCounted": "По ANSI Z765: потолок от {0} м",
  "#StatsDialogAnsiNotLiving": "Выше {0} м меньше половины: по ANSI Z765 не жилая",
  "#StatsDialogAnsiTall": "Из неё потолок от {0} м",
  "#StatsDialogCeilingSlopes": "Скаты потолка",
  "#StatsDialogClose": "Закрыть статистику",
  "#StatsDialogEmpty": "Нарисуйте комнату — здесь появятся её размеры, площади и материалы.",
  "#StatsDialogFilter": "Что считать",
  "#StatsDialogOfWhichSlopes": "Из них скаты",
  "#StatsDialogPrintProject": "проект",
  "#StatsDialogPrintTitle": "Статистика — {0}",
  "#StatsDialogSummaryOf": "{0} — сводка",
  "#StatsDialogValueCubicMeters": "{0} м³",
  "#StopFloorPlansImportButton": "Остановить",
  "#StoreAccessClosed": "Доступ к проекту закрыт.",
  "#StoreAtticNotPossible": "У этой стены уже есть мансарда, или она короче метра.",
  "#StoreCurtainsDoNotFit": "Эти шторы не подходят к проёму.",
  "#StoreLocalSaveFailed": "Не удалось сохранить изменения в браузере. Повторите сохранение или экспортируйте проект.",
  "#StoreNoProject": "Проект не открыт.",
  "#StorePlanNotFound": "План не найден.",
  "#StoreReplaceItemsFailed": "Не удалось заменить предметы.",
  "#StoreSharedBusy": "Проверяем сохранение. Дождитесь подключения перед следующим изменением.",
  "#StoreSharedConflict": "Действие не применено: проект изменился. Обновите проект и повторите редактирование.",
  "#StoreSharedInvalid": "Изменения не сохранены. Проверьте доступность хранилища браузера и повторите.",
  "#Summary": "Сводка",
  "#SwitchTo2D": "2D-план",
  "#TagBalcony": "Балкон",
  "#TagPlinth": "Плинтус",
  "#TagToilet": "Туалет",
  "#TextCopied": "Текст скопирован",
  "#TextureScale": "Масштаб текстуры",
  "#ThickerLabel": "Толще",
  "#ThinnerLabel": "Тоньше",
  "#ThisWeek": "На этой неделе",
  "#TileSizeRange": "Введите размер плитки от 1 см до 20 м.",
  "#Today": "Сегодня",
  "#ToolbarAddMoldings": "Добавить молдинги",
  "#ToolbarAddOpening": "Добавить проём",
  "#ToolbarAddToCeiling": "Добавить на потолок",
  "#ToolbarAddToWall": "Добавить на стену",
  "#ToolbarCeilingBeams": "Потолочные балки и конструкции",
  "#ToolbarCeilingFinish": "Покрытие потолка",
  "#ToolbarCeilingLights": "Потолочные светильники",
  "#ToolbarCloneRoom": "Клонировать комнату",
  "#ToolbarColorAndMaterial": "Цвет и материал",
  "#ToolbarDeleteOpening": "Удалить проём",
  "#ToolbarDeletePoint": "Удалить точку",
  "#ToolbarDeleteRoom": "Удалить комнату",
  "#ToolbarDuplicateItem": "Дублировать предмет",
  "#ToolbarDuplicateOpening": "Дублировать проём",
  "#ToolbarFloorFinish": "Покрытие пола",
  "#ToolbarItem": "Предмет",
  "#ToolbarMoldingHeight": "Высота молдинга",
  "#ToolbarMoreActions": "Ещё действия",
  "#ToolbarMoreOpeningActions": "Ещё действия с проёмом",
  "#ToolbarMoreRoomActions": "Ещё действия с помещением",
  "#ToolbarMoreWallActions": "Ещё действия со стеной",
  "#ToolbarOpening": "Проём",
  "#ToolbarOpeningInsteadOfWall": "Проём вместо стены",
  "#ToolbarOpeningSize": "Размеры проёма",
  "#ToolbarPlinthHeight": "Высота плинтуса",
  "#ToolbarRemoveMolding": "Убрать молдинг",
  "#ToolbarRemoveMoldings": "Убрать молдинги",
  "#ToolbarRemovePlinth": "Убрать плинтус",
  "#ToolbarRemovePlinths": "Убрать плинтусы",
  "#ToolbarReplaceDoor": "Заменить дверь",
  "#ToolbarReplaceItem": "Заменить предмет",
  "#ToolbarReplaceWindow": "Заменить окно",
  "#ToolbarRoomSize": "Размеры помещения",
  "#ToolbarRotateTexture": "Повернуть текстуру на 90°",
  "#ToolbarSizeWdh": "{0} × {1} × {2} м",
  "#ToolbarSizeWh": "{0} × {1} м",
  "#ToolbarSlopedCeiling": "Наклонный потолок",
  "#ToolbarSwingSide": "Сторона открывания",
  "#ToolbarWallSideMaterial": "Материал стороны стены",
  "#ToolbarWallSize": "Размеры стены",
  "#ToolbarWindowView": "Вид из окна",
  "#TryAgainButton": "Попробовать снова",
  "#UnitSquareMeters": "м²",
  "#UpgradeProPlusDescription": "Включает функции PRO, качество фото 4K, неограниченное количество комнат, коммерческое использование и повышенную видимость дизайна",
  "#UpgradeProPlusPlusDescription": "Все преимущества PRO+, а также 360°-фото, экспорт в 3ds Max и видимость в ленте дизайнеров высшего класса",
  "#UpgradeToProPlusPlus": "Перейти на PRO++",
  "#UploadFloorPlanGuidelineTip1": "Один этаж на изображение",
  "#UploadFloorPlanGuidelineTips": "Советы по плану",
  "#UploadPlan": "Загрузить план",
  "#UserNameChangedToGuest": "{0} — теперь гость",
  "#UserNamePromotedToEditor": "{0} — теперь редактор",
  "#UserPermissions": "Люди с доступом",
  "#ValueCentimeters": "{0} см",
  "#ValueMeters": "{0} м",
  "#ValueSquareMeters": "{0} м²",
  "#ViewFaceBack": "Задняя сторона",
  "#ViewFaceBottom": "Низ",
  "#ViewFaceFront": "Передняя сторона",
  "#ViewFaceLeft": "Левый торец",
  "#ViewFaceRight": "Правый торец",
  "#ViewFaceSlope": "Скат",
  "#ViewFaceTop": "Верх",
  "#ViewLoadCanceled": "Загрузка отменена",
  "#ViewLoadTimedOut": "Превышено время загрузки",
  "#ViewModelCatalogEmpty": "Каталог моделей пуст или повреждён",
  "#ViewModelCatalogHttpError": "Каталог моделей: HTTP {0}",
  "#ViewModelDefinitionHttpError": "Описание модели: HTTP {0}",
  "#ViewModelDefinitionNoItem": "В описании модели нет <Item>",
  "#ViewModelHttpError": "Модель: HTTP {0}",
  "#ViewModelLoadTimedOut": "Превышено время загрузки модели",
  "#ViewModelNoDefinition": "У модели нет описания",
  "#ViewPlanAreaAnsi": "по ANSI {0} м²",
  "#ViewPlanSizeCentimeters": "{0} × {1} см",
  "#ViewPlanSizeMeters": "{0} × {1} м",
  "#ViewPlanUnnamedRoom": "Помещение",
  "#Volume": "Объем",
  "#WallElevationPlan2DView": "План стены",
  "#WallLength": "Длина стены",
  "#WallLengthBlocked": "Не получилось изменить длину стены: мешают соседние стены.",
  "#WallLengthRange": "Длина стены: от {0} до {1} м.",
  "#WallModeCutaway": "передние обрезаны",
  "#WallModeFull": "целиком",
  "#WallModeLow": "низкие",
  "#WallsWithOpenings": "Стены с проемами",
  "#WallsWithoutOpenings": "Стены без проемов",
  "#WebAskOwnerForRole": "Разрешить правку может только владелец: попросите у него приглашение с правом правки.",
  "#WebAskToEdit": "Попросить доступ",
  "#WebCanvasMenu": "Меню холста",
  "#WebChatAddressedPublic": "Это сообщение увидят все в чате проекта",
  "#WebCopySaved": "Копия сохранена: {0}",
  "#WebDeveloper": "Разработка",
  "#WebDuplicate": "Дублировать",
  "#WebEditRequestFailed": "Запрос не отправился. Попробуйте ещё раз.",
  "#WebEditRequestSent": "Запрос отправлен",
  "#WebExportOnServer": "Этот экспорт делается на сервере. Он скоро появится.",
  "#WebExportPdf": "PDF",
  "#WebGestureChipDegrees": "{0}°",
  "#WebGoDownStairs": "Спуститься по лестнице",
  "#WebGoUpStairs": "Подняться по лестнице",
  "#WebItemLocked": "Предмет закреплён. Разблокируйте его, чтобы двигать, поворачивать, менять размер или удалять.",
  "#WebKeyboardShortcuts": "Сочетания клавиш",
  "#WebLeaveWalk": "Выйти из прогулки",
  "#WebLiveAcrossWall": "Предмет на стене двигается только вдоль неё.",
  "#WebLiveBadge": "Совместно",
  "#WebLiveCardGone": "Предмет не добавлен: его карточки больше нет в списке. Найдите её снова и нажмите.",
  "#WebLiveChangedInApp": "В приложении только что заменили: {0}. Перенести такой предмет в другую комнату или на другую стену, скопировать или вернуть пока можно только в приложении.",
  "#WebLiveConflict": "Предмет изменил или удалил другой участник — изменение не применено.",
  "#WebLiveEditItemsDesc": "Общий проект. Предметы можно двигать, поворачивать, добавлять, удалять и перекрашивать. Стены, комнаты, проёмы и этажи — в приложении.",
  "#WebLiveEditWaits": "Править можно будет, когда связь восстановится.",
  "#WebLiveItemsOnly": "Стены, комнаты, проёмы и этажи пока меняются только в приложении.",
  "#WebLiveModelNotLoaded": "Модель не загрузилась — попробуйте ещё раз",
  "#WebLiveNoId": "У этого объекта в файле нет номера — изменить его можно только в приложении.",
  "#WebLiveNotConnected": "Нет связи с проектом — изменение не отправлено.",
  "#WebLiveOnlyInApp": "Это можно изменить только в приложении.",
  "#WebLiveOutsideFace": "На внешнюю сторону стены предметы ставят в приложении.",
  "#WebLivePaintInApp": "Покраска частей в общем проекте пока только в приложении. Цвета модели — здесь.",
  "#WebLivePaintPartsInApp": "Покраска частей в общем проекте пока только в приложении.",
  "#WebLivePasteNeedsSource": "В общей комнате копия вставляется только на этаже, где её скопировали, и пока предмет не изменился. Скопируйте его ещё раз.",
  "#WebLivePropsInApp": "Размер, высоту, зеркало и замену модели в общем проекте пока меняют в приложении.",
  "#WebLiveSaveInAppFirst": "Чтобы править здесь, сохраните проект один раз в приложении.",
  "#WebLiveSavedAutomatically": "Изменения сохраняются автоматически, примерно раз в минуту",
  "#WebLiveSavedByApp": "Часть изменений здесь записать нельзя, поэтому сохраняет только приложение. Веб обновит копию после следующего сохранения. Если в проекте нет никого с приложением, правки пропадут, когда все выйдут.",
  "#WebLiveSavedByAppShort": "Сохраняет только приложение",
  "#WebLiveSavedByAppRevision": "Проект сохранён другой версией приложения, и веб его не записывает: сохраняет только приложение. Если в проекте нет никого с приложением, правки пропадут, когда все выйдут.",
  "#WebLiveWallRotateInApp": "Предмет на стене поворачивают в приложении.",
  "#WebLockedStayedFew": "{0} закреплённых предмета остались на месте",
  "#WebLockedStayedMany": "{0} закреплённых предметов остались на месте",
  "#WebLockedStayedOne": "{0} закреплённый предмет остался на месте",
  "#WebObjectMenu": "Меню объекта",
  "#WebParticipantActions": "Действия с участником {0}",
  "#WebParticipantClickForActions": "Нажмите, чтобы открыть действия",
  "#WebParticipantFollow": "Следить",
  "#WebParticipantJoins": "{0} присоединяется",
  "#WebParticipantLeaves": "{0} выходит",
  "#WebParticipantMessage": "Написать {0}",
  "#WebParticipantMessageTip": "Откроет чат проекта: сообщение увидят все его участники",
  "#WebParticipantOpenChat": "Открыть чат",
  "#WebParticipantRemoveText": "Участник выйдет из проекта и вернётся, только если его пригласят снова.",
  "#WebParticipantRemoveTitle": "Закрыть доступ для {0}?",
  "#WebPasteHere": "Вставить сюда",
  "#WebPresenceIn2D": "В 2D",
  "#WebPresenceInOrbit": "В режиме обзора",
  "#WebPresenceInWalk": "На прогулке",
  "#WebPresenceInWalls": "В режиме стен",
  "#WebPresenceInCeiling": "В режиме потолка",
  "#WebPresenceInThisFile": "В этом файле",
  "#WebAgentOf": "Агент {0}",
  "#WebAgentColumnWidth": "Ширина чата",
  "#WebPaywallBuyInApp": "Купить тариф в вебе пока нельзя: {0} оформляется в приложении Home Planner.",
  "#WebFollowLeftProject": "{0} больше нет в проекте",
  "#WebShareAccessGone": "У вас больше нет доступа к этому проекту.",
  "#WebShareAccessOf": "Доступ: {0}",
  "#WebShareAlreadyHasAccess": "{0}: доступ уже есть",
  "#WebShareChangeFailed": "Не удалось сохранить изменение. Примените ещё раз.",
  "#WebShareCheckAddress": "Проверьте адрес",
  "#WebShareClearSearch": "Очистить поиск",
  "#WebShareInviteByEmail": "Пригласить по e-mail",
  "#WebShareInviteFailed": "Не удалось пригласить. Попробуйте ещё раз.",
  "#WebShareInviteFull": "Не удалось пригласить: в проекте больше нет мест.",
  "#WebShareInviteLimitOf": "Не удалось пригласить: в проекте может быть до {0} человек.",
  "#WebShareInviteOwner": "Это адрес владельца: у него уже есть доступ.",
  "#WebShareInviteRole": "Роль приглашённых",
  "#WebShareLinkFailed": "Не удалось получить ссылку. Попробуйте ещё раз чуть позже.",
  "#WebShareLoadFailed": "Не удалось загрузить, у кого есть доступ.",
  "#WebShareLocalNoLink": "Проект в этом браузере никто другой открыть не может",
  "#WebShareNoMemberLink": "Ссылкой на этот проект делится только владелец",
  "#WebShareNoResults": "Никого не нашли по запросу «{0}»",
  "#WebShareSearchFailed": "Поиск не отвечает.",
  "#WebShareSignedOut": "Войдите снова, чтобы увидеть, у кого есть доступ.",
  "#WebShareVisitorsFew": "{0} посетителя",
  "#WebShareVisitorsMany": "{0} посетителей",
  "#WebShareVisitorsOne": "{0} посетитель",
  "#WebTipMultiplayerTools": "Инструменты совместной работы",
  "#WebPresenceMoreInOtherViews": "Ещё {0} — в других видах",
  "#WebPresenceShowEveryone": "Показать всех в проекте",
  "#WebSaveCopy": "Сохранить копию",
  "#WebSessionOpenedElsewhere": "Этот проект открыт с вашего аккаунта в другой вкладке или на другом устройстве. Если подключиться здесь, там проект закроется.",
  "#WebShareApprove": "Одобрить",
  "#WebShareApproveRequest": "Одобрить запрос: {0}",
  "#WebShareAsksToEdit": "Хочет редактировать",
  "#WebShareAsksToView": "Хочет посмотреть",
  "#WebShareDemoLeft": "{0} больше не в проекте",
  "#WebShareDemoOwner": "Владелец проекта",
  "#WebShareDeny": "Отклонить",
  "#WebShareDenyRequest": "Отклонить запрос: {0}",
  "#WebShareGuestDemoNotice": "Это пример: ты видишь проект так, как его видит гость {0}. Запрос отсюда придёт тебе как владельцу.",
  "#WebShareRequestApprovedEdit": "{0} теперь может редактировать",
  "#WebShareRequestApprovedView": "{0} теперь может смотреть проект",
  "#WebShareRequests": "Запросы",
  "#WebShareRequestsWaiting": "Есть запросы доступа",
  "#WebShareViewAsGuest": "Смотреть как гость",
  "#WebShareViewAsOwner": "Вернуться к владельцу",
  "#WebShortcutOrbit": "Вращать вид",
  "#WebShortcutOrbitHow": "Перетаскивание правой кнопкой",
  "#WebShortcutPan": "Сдвинуть вид",
  "#WebShortcutPanHow": "Пробел + перетаскивание или правая кнопка",
  "#WebShortcutPanSpace": "Пробел + перетаскивание",
  "#WebShortcutWalk": "Идти",
  "#WebShortcutWalkHow": "W A S D, стрелки или колесо",
  "#WebShortcutZoom": "Масштаб",
  "#WebShortcutZoomHow": "Колесо или щипок",
  "#WebShortcutsEdit": "Правка",
  "#WebShortcutsNavigation": "Навигация",
  "#WebShortcutsObjects": "Объекты",
  "#WebTabCeilingView": "Потолок",
  "#WebTabWallsView": "Стены",
  "#WebTipCatalog": "Открыть каталог",
  "#WebTipCeilingView": "Перейти к плану потолка",
  "#WebTipCutaway": "Передние стены срезаны",
  "#WebTipDragToReorder": "Перетащите, чтобы переставить",
  "#WebTipFloorMap": "Открыть карту этажа",
  "#WebTipFloorOptions": "Этажи и их настройки",
  "#WebTipFloorPlan": "Перейти к плану пола",
  "#WebTipGallery": "Открыть галерею",
  "#WebTipMore": "Другие действия",
  "#WebTipOpen2D": "Открыть 2D-вид",
  "#WebTipOpen3D": "Открыть 3D-вид",
  "#WebTipOpenAgent": "Открыть ИИ-агента",
  "#WebTipOrbit": "Перейти к обзору",
  "#WebTipPhoto": "Создать фото-рендер",
  "#WebTipWalk": "Перейти к прогулке",
  "#WebTipWallsDown": "Стены опущены",
  "#WebTipWallsUp": "Стены целиком",
  "#WebTipWallsView": "Перейти к виду стен",
  "#WebTipZoom": "Настройки масштаба",
  "#WebUpgradeToPro": "Перейти на PRO",
  "#WebUpgradeToProPlus": "Перейти на PRO+",
  "#WebZoomIn": "Приблизить",
  "#WebZoomInOut": "Приблизить / отдалить",
  "#WebZoomOut": "Отдалить",
  "#WebZoomPercent": "{0} %",
  "#WebZoomTo100": "Масштаб 100 %",
  "#WebZoomToFit": "Вписать в экран",
  "#WindowSlopes": "Оконные откосы",
  "#WindowSlopesNoSill": "Откосы окон (без подоконника)",
  "#WindowType": "Тип окна",
  "#WindowViewBeach": "Пляж",
  "#WindowViewCity": "Город",
  "#WindowViewCityEvening": "Город вечером",
  "#WindowViewClose": "Закрыть вид из окна",
  "#WindowViewGarden": "Сад",
  "#WindowViewLoadFailed": "Не удалось загрузить вид «{0}».",
  "#WindowViewLoading": "Загружаем вид «{0}»…",
  "#WindowViewMeadow": "Луг",
  "#WindowViewMountains": "Горы",
  "#WindowViewNone": "Без вида",
  "#WindowViewNoneNote": "За окнами ровный фон.",
  "#WindowViewRotation": "Поворот вида",
  "#WindowViewSeaSunset": "Закат у моря",
  "#WindowViewSuburb": "Пригород",
  "#WindowViewSunNote": "Солнце в сцене светит с той же стороны, что и на панораме.",
  "#WindowViewTitle": "Вид из окна",
  "#WindowViewTurnLeft": "Повернуть на {0}° влево",
  "#WindowViewTurnRight": "Повернуть на {0}° вправо",
  "#WindowViewWinter": "Зима",
  "#Yesterday": "Вчера",
  "#YourAccessChangedToEdit": "Теперь ты можешь редактировать проект",
  "#YourAccessChangedToView": "Твои права изменены: только просмотр",
  "#ZoomToRoom": "Приблизить",
  "Add Door": "Добавить дверь",
  "Add Window": "Добавить окно",
  "All": "Все",
  "Antique stain": "Античная морилка",
  "Apply": "Применить",
  "Architectural": "Строительство",
  "Back": "Назад",
  "Bathroom": "Ванная",
  "Bedroom": "Спальня",
  "Beech effect": "Эффект бука",
  "Beech veneer": "Шпон бука",
  "Beige": "Бежевый",
  "Birch": "Береза",
  "Birch effect": "Эффект березы",
  "Black": "Черный",
  "Black brown": "Черно-коричневый",
  "Black steel": "Черная сталь",
  "Black-brown": "Черно-коричневый",
  "Blue": "Синий",
  "Brightness": "Яркость",
  "Brown": "Коричневый",
  "Building": "Здание",
  "Camera": "Камера",
  "Cancel": "Отмена",
  "Ceiling": "Потолок",
  "Ceiling Moldings": "Потолочные молдинги",
  "Change Size": "Изменить размер",
  "Chats": "Чаты",
  "Close": "Закрыть",
  "Continue": "Продолжить",
  "Copy": "Копировать",
  "DWG/DXF": "DWG/DXF",
  "Image": "Изображение",
  "Lock": "Закрепить",
  "Copied": "Скопировано",
  "Member": "Участник",
  "Ok": "Ок",
  "Paste": "Вставить",
  "Unlock": "Разблокировать",
  "cm": "см",
  "Color": "Цвет",
  "Colors": "Цвета",
  "Curtains": "Шторы",
  "Delete": "Удалить",
  "Depth": "Глубина",
  "Dimensions": "Размеры",
  "Dining": "Столовая",
  "Done": "Готово",
  "Door": "Дверь",
  "Doors": "Двери",
  "Download": "Скачать",
  "Edit": "Изменить",
  "Error": "Ошибка",
  "Export": "Экспорт",
  "Favorites": "Избранное",
  "Flip": "Отразить",
  "Floor": "Пол",
  "Furniture": "Мебель",
  "Gallery": "Галерея",
  "Gloss gray": "Глянцевый серый",
  "Gloss red": "Глянцевый красный",
  "Golden brown": "Золотой коричневый",
  "Gray": "Серый",
  "Gray brown": "Серо-коричневый",
  "Gray-brown": "Серо-коричневый",
  "Green": "Зеленый",
  "Height": "Высота",
  "High gloss black": "Глянцевый черный",
  "High gloss gray": "Глянцевый серый",
  "High gloss red": "Глянцевый красный",
  "High gloss white": "Глянцевый белый",
  "Items": "Предметы",
  "Join": "Присоединиться",
  "Kitchen": "Кухня",
  "Length": "Длина",
  "Light brown": "Светло-коричневый",
  "Lighting": "Освещение",
  "m": "м",
  "Material": "Материал",
  "Materials": "Материалы",
  "Measure": "Измерить линейкой",
  "Medium brown": "Коричневый ясеневый шпон",
  "Molding": "Молдинг",
  "Move": "Переместить в папку",
  "Multicolor": "Многоцветный",
  "Natural": "Натуральный",
  "No": "Нет",
  "Oak": "Дубовый шпон",
  "Open": "Открыть",
  "Openings": "Проёмы",
  "Other Rooms": "Другие комнаты",
  "Owner": "Владелец",
  "Pause": "Пауза",
  "Pending": "Ожидает",
  "Pink": "Розовый",
  "Plinths": "Плинтусы",
  "Position": "Положение",
  "Reactions": "Реакции",
  "Recent": "Недавние",
  "Red": "Красный",
  "Redo": "Повторить",
  "Rename": "Переименовать",
  "Replace": "Заменить",
  "Reply": "Ответить",
  "Restore": "Восстановить",
  "Retry": "Повторить",
  "Room": "Комната",
  "Rotate": "Повернуть",
  "Saturation": "Насыщенность",
  "Save": "Сохранить",
  "Select": "Выбрать",
  "Send": "Отправить",
  "Settings": "Настройки",
  "Share": "Поделиться",
  "Share project": "Общий доступ к проекту",
  "Sign in": "Войти",
  "Sign out": "Выйти",
  "subscriptionDescription": "Точные измерения, полный каталог, неограниченное количество фото, нестандартные материалы. До 15 дизайнов",
  "Texture": "Текстура",
  "Thickness": "Толщина",
  "Title": "Название",
  "Transparency": "Прозрачность",
  "Undo": "Отменить",
  "Wabi-sabi": "Ваби-саби",
  "Wall": "Стена",
  "Walls": "Стены",
  "Walls Thickness": "Толщина стен",
  "White": "Белый",
  "White stain": "Белая морилка",
  "Width": "Ширина",
  "Window": "Окно",
  "Windows": "Окна",
  "Yellow": "Желтый"
}
